var opend_pop, this_ele;

// A/B Test Start
var is_first_load = 0;
// var pdp_test = function() {
//   // call this function: set condition (if needed) or get existing condition (if present)
  
//   // test settings
//   var variation_names = ["a:1", "b:0"];
//   var cookie_name = "price_test";
//   var ab_condition = document.cookie.match('(^|;)\\s*' + cookie_name + '\\s*=\\s*([^;]+)')?.pop() || '';

//   if (variation_names.indexOf(ab_condition) < 0) {
//     // cookie is not set or doesn't have an existing variation name
//     ab_condition = variation_names[ Math.round(Math.random()*1000) % variation_names.length ];
//   }
  
//   // (re)set the cookie (quick and dirty)
//   var d = new Date();
//   d.setTime(d.getTime()+1000*60*60*24*35); // 35 days from now
//   var expires = "expires="+d.toGMTString();
//   document.cookie = cookie_name + "=" + ab_condition + "; " + expires + "; path=/";
  
//   return ab_condition;
// };

// function ABTextRun(){
//   var analytics_pdp_AB = pdp_test(); // one of: ["a:1", "b:0"]
//   console.log(analytics_pdp_AB,'A/B TEST');
//   if(analytics_pdp_AB == 'a:1') { // current 
//     var testvariation = 0; 
//   } else { // test without decimal
//     var testvariation = 1;
//     var classLoop = [".aa-product-price",".desk_sticky_bar .price",".pro-details .price",".ais-hit--price", ".cart__row .mini_price", ".item-body .price-wrapper", ".subtotalText-wrap", ".product-template__container .price",".cart__footer .cart__subtotal", ".wish_list .p_price"];
//     $.each(classLoop, function(index, val){
//       if ($(val).length > 0){
//         $(val).each(function(i , ele){
//           var priceHtml = $(ele).html();
//           $(ele).html(priceHtml.replace('.00',''));  
//         });
//       }
//     });
//   }
// }
// ABTextRun();
// A/B Test End
// ABBagdeTextRun();

window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});
window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    options.$tables.wrap(
      '<div class="' + options.tableWrapperClass + '"></div>'
    );
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });
      
      if(typeof cariantCallback == 'function' ) {
        cariantCallback(found);
      }

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });
      
      

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();


/* ================ GLOBAL ================ */
/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#PageContainer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false');
    }

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.unbindEvents();

    // Run function when draw closes if set
    if (
      this.config.onDrawerClose &&
      typeof this.config.onDrawerClose === 'function'
    ) {
      this.config.onDrawerClose();
    }
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();


/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function() {
  var selectors = {
    body: 'body',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '.site-nav--has-dropdown',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last'
  };

  var config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link'
  };

  var cache = {};

  function init() {
    cacheSelectors();

    cache.$parents.on('click.siteNav', function(evt) {
      var $el = $(this);

      if (!$el.hasClass(config.activeClass)) {
        // force stop the click from happening
        evt.preventDefault();
        evt.stopImmediatePropagation();
        showDropdown($el);
      }
    });

    // check when we're leaving a dropdown and close the active dropdown
    $(selectors.siteNavChildLink).on('focusout.siteNav', function() {
      setTimeout(function() {
        if (
          $(document.activeElement).hasClass(config.childLinkClass) ||
          !cache.$activeDropdown.length
        ) {
          return;
        }

        hideDropdown(cache.$activeDropdown);
      });
    });

    // close dropdowns when on top level nav
    cache.$topLevel.on('focus.siteNav', function() {
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
    });

    cache.$subMenuLinks.on('click.siteNav', function(evt) {
      // Prevent click on body from firing instead of link
      evt.stopImmediatePropagation();
    });
  }

  function cacheSelectors() {
    cache = {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown)
    };
  }

  function showDropdown($el) {
    $el.addClass(config.activeClass);

    // close open dropdowns
    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown);
    }

    cache.$activeDropdown = $el;

    // set expanded on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');

    setTimeout(function() {
      $(window).on('keyup.siteNav', function(evt) {
        if (evt.keyCode === 27) {
          hideDropdown($el);
        }
      });

      $(selectors.body).on('click.siteNav', function() {
        hideDropdown($el);
      });
    }, 250);
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
    $el.removeClass(config.activeClass);

    // reset active dropdown
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

    $(selectors.body).off('click.siteNav');
    $(window).off('keyup.siteNav');
  }

  function unload() {
    $(window).off('.siteNav');
    cache.$parents.off('.siteNav');
    cache.$subMenuLinks.off('.siteNav');
    cache.$topLevel.off('.siteNav');
    $(selectors.siteNavChildLink).off('.siteNav');
    $(selectors.body).off('.siteNav');
  }

  return {
    init: init,
    unload: unload
  };
})();

window.theme = window.theme || {};

theme.MobileNav = (function() {
  var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    navLinkWrapper: 'mobile-nav__item',
    navLink: 'mobile-nav__link',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu'
  };
  var cache = {};
  var isTransitioning;
  var $activeSubNav;
  var $activeTrigger;
  var menuLevel = 1;
  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  var mediaQuerySmall = 'screen and (max-width: 749px)';

  function init() {
    cacheSelectors();

    cache.$mobileNavToggle.on('click', toggleMobileNav);
    cache.$subNavToggleBtn.on('click.subNav', toggleSubNav);

    // Close mobile nav when unmatching mobile breakpoint
    enquire.register(mediaQuerySmall, {
      unmatch: function() {
        closeMobileNav();
      }
    });
  }

  function toggleMobileNav() {
    if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      $pageContainer: $('#PageContainer'),
      $siteHeader: $('.site-header'),
      $mobileNavToggle: $('.js-mobile-nav-toggle'),
      $mobileNavContainer: $('.mobile-nav-wrapper'),
      $mobileNav: $('#MobileNav'),
      $sectionHeader: $('#shopify-section-header'),
      $subNavToggleBtn: $('.' + classes.subNavToggleBtn)
    };
  }

  function openMobileNav() {
    var translateHeaderHeight =
      cache.$siteHeader.outerHeight() + cache.$siteHeader.position().top;

    cache.$mobileNavContainer.prepareTransition().addClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translateY(' + translateHeaderHeight + 'px)'
    });

    cache.$pageContainer.css({
      transform:
        'translate3d(0, ' + cache.$mobileNavContainer[0].scrollHeight + 'px, 0)'
    });

    slate.a11y.trapFocus({
      $container: cache.$sectionHeader,
      $elementToFocus: cache.$mobileNav
        .find('.' + classes.navLinkWrapper + ':first')
        .find('.' + classes.navLink),
      namespace: 'navFocus'
    });

    cache.$mobileNavToggle
      .addClass(classes.mobileNavCloseIcon)
      .removeClass(classes.mobileNavOpenIcon)
      .attr('aria-expanded', true);

    // close on escape
    $(window).on('keyup.mobileNav', function(evt) {
      if (evt.which === 27) {
        closeMobileNav();
      }
    });
  }

  function closeMobileNav() {
    cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translateY(-100%)'
    });

    cache.$pageContainer.removeAttr('style');

    slate.a11y.trapFocus({
      $container: $('html'),
      $elementToFocus: $('body')
    });

    cache.$mobileNavContainer.one(
      'TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle',
      function() {
        slate.a11y.removeTrapFocus({
          $container: cache.$mobileNav,
          namespace: 'navFocus'
        });
      }
    );

    cache.$mobileNavToggle
      .addClass(classes.mobileNavOpenIcon)
      .removeClass(classes.mobileNavCloseIcon)
      .attr('aria-expanded', false)
      .focus();

    $(window).off('keyup.mobileNav');

    scrollTo(0, 0);
  }

  function toggleSubNav(evt) {
    if (isTransitioning) {
      return;
    }

    var $toggleBtn = $(evt.currentTarget);
    var isReturn = $toggleBtn.hasClass(classes.return);
    isTransitioning = true;

    if (isReturn) {
      // Close all subnavs by removing active class on buttons
      $(
        '.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
      ).removeClass(classes.subNavActive);

      if ($activeTrigger && $activeTrigger.length) {
        $activeTrigger.removeClass(classes.subNavActive);
      }
    } else {
      $toggleBtn.addClass(classes.subNavActive);
    }

    $activeTrigger = $toggleBtn;

    goToSubnav($toggleBtn.data('target'));
  }

  function goToSubnav(target) {
    /*eslint-disable shopify/jquery-dollar-sign-reference */

    var $targetMenu = target
      ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
      : cache.$mobileNav;

    menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;

    if ($activeSubNav && $activeSubNav.length) {
      $activeSubNav.prepareTransition().addClass(classes.subNavClosing);
    }

    $activeSubNav = $targetMenu;

    var $elementToFocus = target
      ? $targetMenu.find('.' + classes.subNavLink + ':first')
      : $activeTrigger;

    /*eslint-enable shopify/jquery-dollar-sign-reference */

    var translateMenuHeight = $targetMenu.outerHeight();

    var openNavClass =
      menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;

    cache.$mobileNavContainer
      .css('height', translateMenuHeight)
      .removeClass(classes.thirdNavShowing)
      .addClass(openNavClass);

    if (!target) {
      // Show top level nav
      cache.$mobileNavContainer
        .removeClass(classes.thirdNavShowing)
        .removeClass(classes.subNavShowing);
    }

    // Focusing an item in the subnav early forces element into view and breaks the animation.
    cache.$mobileNavContainer.one(
      'TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle',
      function() {
        slate.a11y.trapFocus({
          $container: $targetMenu,
          $elementToFocus: $elementToFocus,
          namespace: 'subNavFocus'
        });

        cache.$mobileNavContainer.off('.subnavToggle');
        isTransitioning = false;
      }
    );

    // Match height of subnav
    cache.$pageContainer.css({
      transform: 'translateY(' + translateMenuHeight + 'px)'
    });

    $activeSubNav.removeClass(classes.subNavClosing);
  }

  return {
    init: init,
    closeMobileNav: closeMobileNav
  };
})(jQuery);

window.theme = window.theme || {};

theme.Search = (function() {
  var selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',

    siteHeader: '.site-header',
    siteHeaderSearchToggle: '.site-header__search-toggle',
    siteHeaderSearch: '.site-header__search',

    searchDrawer: '.search-bar',
    searchDrawerInput: '.search-bar__input',

    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit',

    mobileNavWrapper: '.mobile-nav-wrapper'
  };

  var classes = {
    focus: 'search--focus',
    mobileNavIsOpen: 'js-menu--is-open'
  };

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    initDrawer();
    searchSubmit();

    $(selectors.searchHeaderInput)
      .add(selectors.searchHeaderSubmit)
      .on('focus blur', function() {
        $(selectors.searchHeader).toggleClass(classes.focus);
      });

    $(selectors.siteHeaderSearchToggle).on('click', function() {
      var searchHeight = $(selectors.siteHeader).outerHeight();
      var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;

      $(selectors.searchDrawer).css({
        height: searchHeight + 'px',
        top: searchOffset + 'px'
      });
    });
  }

  function initDrawer() {
    // Add required classes to HTML
    $('#PageContainer').addClass('drawer-page-content');
    $('.js-drawer-open-top')
      .attr('aria-controls', 'SearchDrawer')
      .attr('aria-expanded', 'false')
      .attr('aria-haspopup', 'dialog');

    theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: searchDrawerFocus,
      onDrawerClose: searchDrawerFocusClose
    });
  }

  function searchDrawerFocus() {
    searchFocus($(selectors.searchDrawerInput));

    if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
      theme.MobileNav.closeMobileNav();
    }
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchDrawerFocusClose() {
    $(selectors.siteHeaderSearchToggle).focus();
  }

  function searchSubmit() {
    $(selectors.searchSubmit).on('click', function(evt) {
      var $el = $(evt.target);
      var $input = $el.parents(selectors.search).find(selectors.searchInput);
      if ($input.val().length === 0) {
        evt.preventDefault();
        searchFocus($input);
      }
    });
  }

  return {
    init: init
  };
})();

(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };

  function slideshow(el) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);

    this.settings = {
      accessibility: true,
      arrows: false,
      dots: true,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.$slideshow.data('autoplay'),
      autoplaySpeed: this.$slideshow.data('speed')
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);

    this.$pause.on('click', this.togglePause.bind(this));
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    $wrapper.on('focusin', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Resume autoplay
    $wrapper.on('focusout', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        // Manual check if the focused element was the video close button
        // to ensure autoplay does not resume when focus goes inside YouTube iframe
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }

        $slider.slick('slickPlay');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function(evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        if (evt.which === 37 || evt.which === 39) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find('.' + classes.currentSlide);
    var $nextSlide = $slider.find(
      '.slideshow__slide[data-slick-index="' + nextSlide + '"]'
    );

    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find('.' + classes.video);
      var currentVideoId = $currentVideo.attr('id');
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr('tabindex', '-1');
    }

    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find('.' + classes.video);
      var videoId = $video.attr('id');
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr('tabindex', '0');
      }
    }
  }

  function isVideoInSlide($slide) {
    return $slide.find('.' + classes.video).length;
  }

  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick('slickPlay');
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick('slickPause');
    }
  };

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}

theme.SlideshowVideo = (function() {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    slideshowWrapper: 'slideshow-wrapper',
    slide: 'slideshow__slide',
    slideBackgroundVideo: 'slideshow__slide--background-video',
    slideDots: 'slick-dots',
    videoChrome: 'slideshow__video--chrome',
    videoBackground: 'slideshow__video--background',
    playVideoBtn: 'slideshow__video-control--play',
    closeVideoBtn: 'slideshow__video-control--close',
    currentSlide: 'slick-current',
    slickClone: 'slick-cloned',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay'
  };

  /**
   * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return;
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status: $video.data('type') === 'chrome' ? 'closed' : 'background', // closed, open, background
      videoSelector: $video.attr('id'),
      $parentSlide: $video.closest('.' + classes.slide),
      $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
      controls: $video.data('type') === 'background' ? 0 : 1,
      slideshow: $video.data('slideshow')
    };

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }

  function customPlayVideo(playerId) {
    // Do not autoplay just because the slideshow asked you to.
    // If the slideshow asks to play a video, make sure
    // we have done the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return;
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === 'function'
    ) {
      videoPlayers[playerId].pauseVideo();
    }
  }

  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }

    initEvents();
    youtubeLoaded = true;
  }

  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);

    initEvents();
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }

  function setAutoplaySupport(supported) {
    var supportClass = supported
      ? classes.supportsAutoplay
      : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass);

    if (!supported) {
      playOnClick = true;
    }

    autoplayCheckComplete = true;
  }

  function autoplayCheckFunction(player, $slide) {
    // attempt to play video
    player.playVideo();

    autoplayTest(player)
      .then(function() {
        setAutoplaySupport(true);
      })
      .fail(function() {
        // No autoplay available (or took too long to start playing).
        // Show fallback image. Stop video for safety.
        setAutoplaySupport(false);
        player.stopVideo();
      })
      .always(function() {
        autoplayCheckComplete = true;
        $slide.removeClass(classes.loading);
      });
  }

  function autoplayTest(player) {
    var deferred = $.Deferred();
    var wait;
    var timeout;

    wait = setInterval(function() {
      if (player.getCurrentTime() <= 0) {
        return;
      }

      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);

    timeout = setTimeout(function() {
      clearInterval(wait);
      deferred.reject();
    }, 4000); // subjective. test up to 8 times over 4 seconds

    return deferred;
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return;
    }

    if ($(window).width() < 750) {
      playOnClick = true;
    } else if (window.mobileCheck()) {
      playOnClick = true;
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false);
    }

    playOnClickChecked = true;
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);

    playOnClickCheck();

    // Prevent tabbing through YouTube player controls until visible
    $('#' + videoData.id).attr('tabindex', '-1');

    sizeBackgroundVideos();

    // Customize based on options from the video ID
    switch (videoData.type) {
      case 'background-chrome':
      case 'background':
        evt.target.mute();
        // Only play the video if it is in the active slide
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }

    videoData.$parentSlide.addClass(classes.loaded);
  }

  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);

    switch (evt.data) {
      case 0: // ended
        setAsFinished(videoData);
        break;
      case 1: // playing
        setAsPlaying(videoData);
        break;
      case 2: // paused
        setAsPaused(videoData);
        break;
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'background-chrome':
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case 'chrome':
        closeVideo(videoData.id);
        break;
    }
  }

  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    $slide.removeClass(classes.loading);

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return;
    }

    $('#' + videoData.id).attr('tabindex', '0');

    switch (videoData.type) {
      case 'chrome':
      case 'background-chrome':
        $slideshow.removeClass(classes.paused).addClass(classes.playing);
        $slide.removeClass(classes.paused).addClass(classes.playing);
        break;
    }

    // Update focus to the close button so we stay within the slide
    $slide.find('.' + classes.closeVideoBtn).focus();
  }

  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;

    if (videoData.type === 'background-chrome') {
      closeVideo(videoData.id);
      return;
    }

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.status !== 'closed' && videoData.type !== 'background') {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }

    if (videoData.type === 'chrome' && videoData.status === 'closed') {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }

    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }

  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(' ');

    $('#' + videoData.id).attr('tabindex', '-1');

    videoData.status = 'closed';

    switch (videoData.type) {
      case 'background-chrome':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case 'chrome':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData); // in case the video is already paused
        break;
    }

    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }

  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }

  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    // add loading class to slide
    videoData.$parentSlide.addClass(classes.loading);

    videoData.status = 'open';

    switch (videoData.type) {
      case 'background-chrome':
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case 'chrome':
        privatePlayVideo(playerId, true);
        break;
    }

    // esc to close video player
    $(document).on('keydown.videoPlayer', function(evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }

  function sizeBackgroundVideos() {
    $('.' + classes.videoBackground).each(function(index, el) {
      sizeBackgroundVideo($(el));
    });
  }

  function sizeBackgroundVideo($player) {
    var $slide = $player.closest('.' + classes.slide);
    // Ignore cloned slides
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var playerWidth = $player.width();
    var playerHeight = $player.height();

    // when screen aspect ratio differs from video, video must center and underlay one dimension
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio); // get new player width
      $player
        .width(playerWidth)
        .height(playerHeight)
        .css({
          left: (slideWidth - playerWidth) / 2,
          top: 0
        }); // player width is greater, offset left; reset top
    } else {
      // new video width < window width (gap to right)
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio); // get new player height
      $player
        .width(slideWidth)
        .height(playerHeight)
        .css({
          left: 0,
          top: (playerHeight - playerHeight) / 2
        }); // player height is greater, offset top; reset left
    }

    $player.prepareTransition().addClass(classes.loaded);
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background-chrome to a chrome-only player once played
    $('#' + playerId)
      .removeAttr('style')
      .removeClass(classes.videoBackground)
      .addClass(classes.videoChrome);

    videos[playerId].$parentSlideshowWrapper
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].$parentSlide
      .removeClass(classes.slideBackgroundVideo)
      .addClass(classes.playing);

    videos[playerId].status = 'open';
  }

  function setBackgroundVideo(playerId) {
    // Switch back to background-chrome when closed
    var $player = $('#' + playerId)
      .addClass(classes.videoBackground)
      .removeClass(classes.videoChrome);

    videos[playerId].$parentSlide.addClass(classes.slideBackgroundVideo);

    videos[playerId].status = 'background';
    sizeBackgroundVideo($player);
  }

  function initEvents() {
    $(document).on('click.videoPlayer', '.' + classes.playVideoBtn, function(
      evt
    ) {
      var playerId = $(evt.currentTarget).data('controls');
      startVideoOnClick(playerId);
    });

    $(document).on('click.videoPlayer', '.' + classes.closeVideoBtn, function(
      evt
    ) {
      var playerId = $(evt.currentTarget).data('controls');
      closeVideo(playerId);
    });

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on(
      'resize.videoPlayer',
      $.debounce(250, function() {
        if (youtubeLoaded) {
          sizeBackgroundVideos();
        }
      })
    );
  }

  function removeEvents() {
    $(document).off('.videoPlayer');
    $(window).off('.videoPlayer');
  }

  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();


/* ================ TEMPLATES ================ */
(function() {
  var $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function() {
    location.href = $(this).val();
  });
})();

window.theme = theme || {};

theme.customerTemplates = (function() {
  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink('/account/addresses/' + formId, {
          parameters: { _method: 'delete' }
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();


/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function() {
  var selectors = {
    edit: '.js-edit-toggle'
  };
  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active',
    cartNoCookies: 'cart--no-cookies'
  };

  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }

    this.$edit.on('click', this._onEditClick.bind(this));
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function() {
      this.$edit.off('click', this._onEditClick);
    },

    _onEditClick: function(evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $('.' + $evtTarget.data('target'));

      $evtTarget.toggleClass(config.showEditClass);
      $updateLine.toggleClass(config.showClass);
    },

    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
      }
      return cookieEnabled;
    }
  });
  
  return Cart;
  
})();

window.theme = window.theme || {};

theme.Filters = (function() {
  var constants = {
    SORT_BY: 'sort_by'
  };
  var selectors = {
    filterSelection: '#SortTags',
    sortSelection: '#SortBy',
    defaultSort: '#DefaultSortBy'
  };

  function Filters(container) {
    var $container = (this.$container = $(container));

    this.$filterSelect = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add(
      $(selectors.sortSelection, $container)
    );

    this.defaultSort = this._getDefaultSortValue();
    this._resizeSelect(this.$selects);
    this.$selects.removeClass('hidden');

    this.$filterSelect.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _onSortChange: function(evt) {
      var sort = this._sortValue();
      if (sort.length) {
        window.location.search = sort;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = window.location.href.replace(
          window.location.search,
          ''
        );
      }
      this._resizeSelect($(evt.target));
    },

    _onFilterChange: function(evt) {
      var filter = this._getFilterValue();

      // remove the 'page' parameter to go to the first page of results
      var search = document.location.search.replace(/\?(page=\w+)?&?/, '');

      // only add the search parameters to the url if they exist
      search = search !== '' ? '?' + search : '';

      document.location.href = filter + search;
      this._resizeSelect($(evt.target));
    },

    _getFilterValue: function() {
      return this.$filterSelect.val();
    },

    _getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return $(selectors.defaultSort, this.$container).val();
    },

    _sortValue: function() {
      var sort = this._getSortValue();
      var query = '';

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + '=' + sort;
      }

      return query;
    },

    _resizeSelect: function($selection) {
      $selection.each(function() {
        var $this = $(this);
        var arrowWidth = 10;
        // create test element
        var text = $this.find('option:selected').text();
        var $test = $('<span>').html(text);

        // add to body, get width, and get out
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();

        // set select width
        $this.width(width + arrowWidth);
      });
    },

    onUnload: function() {
      this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return Filters;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function() {
  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    //theme.Search.init();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload();
    }
  });

  return Header;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]'
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function() {
    if (!Shopify.designMode) {
      return;
    }

    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapOverlay).after(
      '<div class="' +
        classes.errorMsg +
        '">' +
        theme.strings.authError +
        '</div>'
    );
  };

  function Map(container) {
    this.$container = $(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');

    if (typeof this.key === 'undefined') {
      return;
    }

    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);

      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$map;

      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            //eslint-disable-next-line no-unused-vars
            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter()
            });

            google.maps.event.addDomListener(
              window,
              'resize',
              $.debounce(250, function() {
                google.maps.event.trigger(map, 'resize');
                map.setCenter(center);
                $map.removeAttr('style');
              })
            );
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = errors.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = errors.addressQueryLimit;
              break;
            case 'REQUEST_DENIED':
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html(
                '<div class="' +
                  classes.errorMsg +
                  '">' +
                  errorMessage +
                  '</div>'
              );
          }
        });
    },

    onUnload: function() {
      if (this.$map.length === 0) {
        return;
      }
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

/* eslint-disable no-new */
theme.Product = (function() {
  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };

    this.selectors = {
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      originalPrice: '#ProductPrice-' + sectionId,
      SKU: '.variant-sku',
      originalPriceWrapper: '.product-price__price-' + sectionId,
      originalSelectorId: '#ProductSelect-' + sectionId,
      productImageWraps: '.product-single__photo',
      productPrices: '.product-single__price-' + sectionId,
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      saleClasses: 'product-price__sale product-price__sale--single',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      priceContainer: '[data-price]',
      regularPrice: '[data-regular-price]',
      salePrice: '[data-sale-price]',
      unitPrice: '[data-unit-price]',
      unitPriceBaseUnit: '[data-unit-price-base-unit]'
    };

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + sectionId).innerHTML
    );

    this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
      'js-zoom-enabled'
    );

    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._setActiveThumbnail();
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function() {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          // initialize thumbnail slider on mobile if more than three thumbnails
          if ($(self.selectors.productThumbImages).length > 3) {
            self._initThumbnailSlider();
          }

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _destroyZoom(this);
            });
          }

          self.settings.bpSmall = true;
        },
        unmatch: function() {
          if (self.settings.sliderActive) {
            self._destroyThumbnailSlider();
          }

          self.settings.bpSmall = false;
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _enableZoom(this);
            });
          }
        }
      });
    },

    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAddToCart.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
    },

    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages).on('click', function(evt) {
        evt.preventDefault();
        var $el = $(this);

        var imageId = $el.data('thumbnail-id');

        self._switchImage(imageId);
        self._setActiveThumbnail(imageId);
      });
    },

    _setActiveThumbnail: function(imageId) {
      var activeClass = 'active-thumb';

      // If there is no element passed, find it by the current product image
      if (typeof imageId === 'undefined') {
        imageId = $(this.selectors.productImageWraps + ":not('.hide')").data(
          'image-id'
        );
      }

      var $thumbnail = $(
        this.selectors.productThumbImages +
          "[data-thumbnail-id='" +
          imageId +
          "']"
      );
      $(this.selectors.productThumbImages).removeClass(activeClass);
      $thumbnail.addClass(activeClass);
    },

    _switchImage: function(imageId) {
      var $newImage = $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
        this.$container
      );
      var $otherImages = $(
        this.selectors.productImageWraps +
          ":not([data-image-id='" +
          imageId +
          "'])",
        this.$container
      );
      $newImage.removeClass('hide');
      $otherImages.addClass('hide');
    },

    _initThumbnailSlider: function() {
      var options = {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: false,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      };

      $(this.selectors.productThumbs).slick(options);
      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(this.selectors.productPrices)
          .removeClass('visibility-hidden')
          .attr('aria-hidden', 'true');

        if (variant.available) {
          $(this.selectors.addToCart).prop('disabled', false);
          $(this.selectors.addToCartText).text(theme.strings.addToCart);
          $(this.selectors.shopifyPaymentButton, this.$container).show();
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCartText).text(theme.strings.soldOut);
          $(this.selectors.shopifyPaymentButton, this.$container).hide();
        }
      } else {
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.addToCartText).text(theme.strings.unavailable);
        $(this.selectors.productPrices)
          .addClass('visibility-hidden')
          .attr('aria-hidden', 'false');
        $(this.selectors.shopifyPaymentButton, this.$container).hide();
      }
    },

    _updateImages: function(evt) {
      var variant = evt.variant;
      var imageId = variant.featured_image.id;

      this._switchImage(imageId);
      this._setActiveThumbnail(imageId);
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      // Update the product price
      $(this.selectors.originalPrice).html(
        theme.Currency.formatMoney(variant.price, theme.moneyFormat)
      );

      // Update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        $(this.selectors.comparePrice)
          .html(
            theme.Currency.formatMoney(
              variant.compare_at_price,
              theme.moneyFormat
            )
          )
          .removeClass('hide');

        $(this.selectors.originalPriceWrapper).addClass(
          this.selectors.saleClasses
        );

        $(this.selectors.saleLabel).removeClass('hide');
      } else {
        $(this.selectors.comparePrice).addClass('hide');
        $(this.selectors.saleLabel).addClass('hide');
        $(this.selectors.originalPriceWrapper).removeClass(
          this.selectors.saleClasses
        );
      }
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      // Update the sku
      $(this.selectors.SKU).html(variant.sku);
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  function _enableZoom(el) {
    var zoomUrl = $(el).data('zoom');
    $(el).zoom({
      url: zoomUrl
    });
  }

  function _destroyZoom(el) {
    $(el).trigger('zoom.destroy');
  }

  return Product;
})();

theme.Quotes = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3
  };

  function Quotes(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var wrapper = (this.wrapper = '.quotes-wrapper');
    var slider = (this.slider = '#Quotes-' + sectionId);
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $(
        '.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Quotes;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId);

    $('.slideshow__video', slideshow).each(function() {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function() {
      // Resume autoplay
      $(this.slideshow).slick('slickPlay');
    }
  }
);


$(document).ready(function() {
  var sections = new theme.Sections();

  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('quotes', theme.Quotes);
});

theme.init = function() {
  theme.customerTemplates.init();

  // Theme-specific selectors to make tables scrollable
  var tableSelectors = '.rte table,' + '.custom__item-inner--html table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'scrollable-wrapper'
  });

  // Theme-specific selectors to make iframes responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"],' +
    '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
    '.custom__item-inner--html iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'video-wrapper'
  });

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });
};



$(theme.init);

// Cart upsell collection
function cartCollectionSlider(){
  if($('.cart-upsell-slider').length != 0 ){
    $('.cart-upsell-slider').slick({
        infinite: true,
        arrows: true,
        dots: false,
        autoplay: false,
        speed: 1000,
        accessibility: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        prevArrow: $('.n-prev-arrow'),
        nextArrow: $('.n-next-arrow'),
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 2
                },
            },
            {
                breakpoint: 767,
                settings: {
                  slidesToShow: 2                
                }
            }
        ]
    });
  }
}

function closePopup() {
  $('.popupBox').removeClass('slideInDown');
  $('.popupBox').addClass('slideOutUp');
  $('.popupOverlay').fadeOut('slow');
}

function refresh_minicart() {
  $.get("/cart?view=mini&" + Math.random(), function( data ) {
    // $('body .mini-shopping-cart').html(data);
    var new_data = data.split('[cartsplit]');
     $('body .mini-shopping-cart .main-cart-dt-rep').html(new_data[0]);
     $('body .mini-shopping-cart .cart__subtotal').html(new_data[1]);
     
    if ($('#smallcart').find('.empty-page-content1').length == 0){
      $('footer.cart__footer').show();
    } else {
      $('footer.cart__footer').hide();
    }
    cartCollectionSlider();
    // ABTextRun();
    // ABBagdeTextRun();
    var GWPEle = new_data[2];
    addFreeGiftProduct('add', GWPEle);
  });
  setTimeout(function(){
    document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  },500);
}

// Shopping gives
var c = 0;
function shoppingGivesWidget(){
 if($('.sg-custom-cart-target').length > 0){
      var remove_script = document.querySelector("[data-script_type='shopping_give']");
      remove_script.parentNode.removeChild(remove_script);
      
      var s = document.createElement("script");
      s.type = "text/javascript";
      // s.src = "https://cdn.shoppinggives.com/cc-utilities/shopify-cart.js?store-id=33de47ed-b855-4a44-90d4-54b17a07c8ae&template-type=0&target-element=.sg-custom-cart-target";
      s.src = "https://cdn.shoppinggives.com/cc-utilities/shopify-add-on.js?sid=33de47ed-b855-4a44-90d4-54b17a07c8ae&variants=39995367718978-1,39995367751746-3,39995367784514-5,39995367817282-10";
      s.dataset.script_type = "shopping_give";
      $("head").append(s);
      widgetfound();
    }
}

function widgetfound(){
  if($('.sg-widget').find('.shoppinggives-tag').length > 0){
      var all_widget = $('#sg-custom-widgets-container').find('.sg-widget');
      $.each(all_widget,function(i, val) {
        if ($(val).find('.shoppinggives-tag').length == 0){
            $(val).remove();
        }
      });
    $('#sg-custom-widgets-container').show();
  }else{
      if(c < 50){
      setTimeout(function(){
        c++;
        widgetfound();
      },1000);
    }
  }
}

function updateCartEvent(data, event, ip) {
  if (data) {
    var expectedShipDate = data.properties != null ? data.properties['EXPECTED SHIP DATE'] != null ? data.properties['EXPECTED SHIP DATE'] : '' : '';
    var size = data.variant_options.length > 1 ? data.variant_options[1].trim() : '';
    var dataEvent = {
      event: "updateCart",
    }
    if (ip) {
      var qty = ip;
    } else {
      var qty = data.quantity;
    }
    if (event == 'add') {
      dataEvent.addToCart = {
        products: [
          {
            id: data.product_id,
            sku: data.variant_id,
            style: data.sku,
            name: data.title,
            price: (parseInt(data.final_price)/100).toFixed(2),
            basePrice: (parseInt(data.original_price)/100).toFixed(2),
            quantity: qty,
            brand: data.vendor,			
            color: data.variant_options[0].trim(),
            colorFamily: data.variant_options[0].trim(),
            size: size,
            expectedShipDate: expectedShipDate
          }
        ]
      }
    } else {
      dataEvent.removeFromCart = {
        products: [
          {
            id: data.product_id,
            sku: data.variant_id,
            style: data.sku,
            name: data.title,
            price: (parseInt(data.final_price)/100).toFixed(2),
            basePrice: (parseInt(data.original_price)/100).toFixed(2),
            quantity: qty,
            brand: data.vendor,			
            color: data.variant_options[0].trim(),
            colorFamily: data.variant_options[0].trim(),
            size: size,
            expectedShipDate: expectedShipDate
          }
        ]
      }
    }
    $.getJSON('/cart.js', function(c) {
      dataEvent.cart = {
        "total": c.total_price,
        "count": c.item_count,
        "products": []
      }
      $(c.items).each(function(i, v) {
        var expectedShipDate = v.properties != null ? v.properties['EXPECTED SHIP DATE'] != null ? v.properties['EXPECTED SHIP DATE'] : '' : '';
        var size = v.variant_options.length > 1 ? v.variant_options[1].trim() : '';
        dataEvent.cart.products.push({
          id: v.product_id,
          sku: v.variant_id,
          style: v.sku,
          name: v.title,
          price: (parseInt(v.final_price)/100).toFixed(2),
          basePrice: (parseInt(v.original_price)/100).toFixed(2),
          quantity: v.quantity,
          brand: v.vendor,			
          color: v.variant_options[0].trim(),
          colorFamily: v.variant_options[0].trim(),
          size: size,
          expectedShipDate: expectedShipDate
        });
      });
      dataEvent._clear = true;
      window.dataLayer.push(dataEvent);
    });
  }
}

// Free Gift Product Start
// function giftProduct(foundCustomer, free_gift_id, freeGiftFound, evnt){
//   var freegiftProp = false;
//   console.log('GWP Eligible: ', foundCustomer);
//   if (foundCustomer){
//     $.getJSON('/cart.js', function(c) {
//       if (c.items.length == 1 && evnt == 'remove' || c.items.length == 1 && evnt == 'update'){
//         $(c.items).each(function(i, v) { 
//           if(Object.keys(v.properties).length > 0){
//             $(v.properties).each(function(i, prop){
//               if (prop.hasOwnProperty('_free_product')){
//                 freegiftProp = true;
//                 return false;
//               }
//             });
//           }
//           if (v.id == free_gift_id && freegiftProp == true){
//            $.ajax({
//               type: "POST",
//               dataType: "json",
//               url: "/cart/update.js",
//               data: "updates["+free_gift_id+"]=0",
//               async: false
//             }).done(function(){
//              console.log('Free Gift Removed Successfully');
//              refresh_minicart();
//              $.getJSON('/cart.js', function(c){
//                 $('.mini-cart .cart-icon > span:not(.sr-only)').html(c.item_count);
//              });
//            });
//           } 
//         });
//       }
//       $(c.items).each(function(i, v) { 
//         if(Object.keys(v.properties).length > 0){
//           $(v.properties).each(function(i, prop){
//             if (prop.hasOwnProperty('_free_product')){
//               freegiftProp = true;
//               return false;
//             }
//           });
//         }
//         if (v.id == free_gift_id && freegiftProp == true){ 
//           freeGiftFound = true; 
//           return false;
//         } 
//       });
//       console.log('Free Gift Found: ',freeGiftFound);
//       if (freeGiftFound == false && freegiftProp == false && evnt == 'add' || freeGiftFound == false && freegiftProp == false && evnt == 'update'){
//         jQuery.ajax({
//           type: 'POST',
//           url: '/cart/add.js',
//           async: false,
//           data: { "quantity": 1, "id": free_gift_id, "properties" : {"_free_product": "YES"}},
//           dataType: 'json',
//           success: function(itemData) {
//             console.log('Free Gift Added Successfully');
//             setTimeout(function() {
//               updateCartEvent(itemData, 'add', 1)
//             }, 1000);
//             refresh_minicart();
//             $.getJSON('/cart.js', function(c){
//               $('.mini-cart .cart-icon > span:not(.sr-only)').html(c.item_count);
//             });
//           }
//         });
//       }
//     });
//   }
// }

// function addFreeGiftProduct(evnt){
//     if ($('body').attr('data-free_gift') != undefined && $('body').attr('data-customer_id') != undefined || $('body').attr('data-free_gift') != undefined){
//       var free_gift_id = parseInt($('body').attr('data-free_gift')), freeGiftFound = false, foundCustomer = false;
//       $.getJSON('/cart.js', function(c) {
//         if (c.items.length == 1 && evnt == 'remove' || c.items.length == 1 && evnt == 'update'){
//           $(c.items).each(function(i, v) { 
//             if(Object.keys(v.properties).length > 0){
//               $(v.properties).each(function(i, prop){
//                 if (prop.hasOwnProperty('_free_product')){
//                   freegiftProp = true;
//                   return false;
//                 }
//               });
//             }
//             if (v.id == free_gift_id && freegiftProp == true){
//              $.ajax({
//                 type: "POST",
//                 dataType: "json",
//                 url: "/cart/update.js",
//                 data: "updates["+free_gift_id+"]=0",
//                 async: false
//               }).done(function(){
//                console.log('Free Gift Removed Successfully');
//                refresh_minicart();
//                $.getJSON('/cart.js', function(c){
//                   $('.mini-cart .cart-icon > span:not(.sr-only)').html(c.item_count);
//                });
//                if($('.cartItemData').length > 0){
//                  $.get( "/cart", function( data ) {
//                   $('.cartItemData').html($(data).find('.cartItemData').html());
//                 });
//                }
//              });
//             } 
//           });
//         }
//      });
//       if ($('body').attr('data-customer_id') != undefined){
//         var customer_id = parseInt($('body').attr('data-customer_id'));
//          $.ajax({
//           type: "GET" ,
//           headers: {
//             'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
//           },
//           crossDomain: true,
//           url: "https://customerapi.dolcevita.com/findCustomerSMSsubcription/"+customer_id,
//           dataType: "json",
//           success: function(xml) {
//             if (xml != null){
//               if (xml.state == "subscribed"){
//                 foundCustomer = true;
//               } else if (xml.state == "not_subscribed"){
//                 foundCustomer = false;
//               }
//             } else {
//               foundCustomer = false;
//             }
//             giftProduct(foundCustomer, free_gift_id, freeGiftFound,evnt)
//           },
//           error: function(response){
//             console.log(response);
//           }
//         });
//     }
//     if (window.location.href.indexOf('utm_source=attentive') > -1 || (getCookie('GWP-free-utm') != '' && getCookie('GWP-free-utm') == 'hasFree')){
//       foundCustomer = true;
//       giftProduct(foundCustomer, free_gift_id, freeGiftFound,evnt)
//     }
//   }
// }
// Free Gift Product End

// Free Gift Product Start 08-08-23
function giftProduct(free_gift_id, GWPEligible, evnt){ // DV Towel GWP - 07-08-23
  var freegiftProp = false, currentKey, freeGiftFound = false;
    console.log('Free Gift Eligible: ',GWPEligible);
    $.getJSON('/cart.js', function(c) {
      var v_id;
      $(c.items).each(function(i, v) { 
        if(Object.keys(v.properties).length > 0){
          $(v.properties).each(function(i, prop){
            if (prop.hasOwnProperty('_free_product')){
              freegiftProp = true;
              currentKey = v.key;
              return false;
            }
          });
        }
        if (v.id == free_gift_id && freegiftProp == true){ 
          freeGiftFound = true;
          v_id = v.id;
          return false;
        } 
      });
      if (evnt == 'remove' && GWPEligible == 0 || evnt == 'update' && GWPEligible == 0){
        if (v_id == free_gift_id && freegiftProp == true){
         $.ajax({
            type: "POST",
            dataType: "json",
            url: "/cart/change.js",
            data: { quantity: 0, id: currentKey },
            async: false
          }).done(function(){
           console.log('Free Gift Removed Successfully');
           $.getJSON('/cart.js', function(c){
              $('.mini-cart .cart-icon > span:not(.sr-only)').html(c.item_count);
           });
           if($('.cartItemData').length > 0){
             $.get( "/cart", function( data ) {
              $('.cartItemData').html($(data).find('.cartItemData').html());
            });
             // ABTextRun();
             // ABBagdeTextRun();
           } else {
             refresh_minicart();
           }
         });
        } 
      }
      console.log('Free Gift Found: ',freeGiftFound);
      if (freeGiftFound == false && freegiftProp == false && evnt == 'add' && GWPEligible == 1 || freeGiftFound == false && freegiftProp == false && evnt == 'update' && GWPEligible == 1){
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          async: false,
          data: { "quantity": 1, "id": free_gift_id, "properties" : {"_free_product": "YES"}},
          dataType: 'json',
          success: function(itemData) {
            console.log('Free Gift Added Successfully');
            setTimeout(function() {
              updateCartEvent(itemData, 'add', 1)
            }, 1000);
            $.getJSON('/cart.js', function(c){
              $('.mini-cart .cart-icon > span:not(.sr-only)').html(c.item_count);
            });
            if($('.cartItemData').length > 0){
              $.get( "/cart", function( data ) {
                $('.cartItemData').html($(data).find('.cartItemData').html());
              });
              // ABTextRun();
              // ABBagdeTextRun();
            } else {
              refresh_minicart();
            }
          }
        });
      }
    });
}

function addFreeGiftProduct(evnt, GWPEligible){ // DV Towel GWP - 07-08-23
  if ($('body').attr('data-free_gift') != undefined){
    var free_gift_id = parseInt($('body').attr('data-free_gift'));
    giftProduct(free_gift_id, GWPEligible, evnt)
  }
}
// Free Gift Product End

$(document).ready(function(e) {
  cartCollectionSlider();
  $('body').on('click','.openQv', function(e){
    $(this).attr('disabled','disabled');
    $('.qvProduct').removeAttr('style');
    var url = $(this).data("href");
    var newurl = "";
    if(url.toLocaleLowerCase().indexOf("?ref=isp_rel_no_match")!=-1){
     var spit = url.split('?');
    newurl = newurl+ spit[0];
      url = newurl;
    }
    console.log(url)
    e.preventDefault();
    $.get( url+'?view=quick_view', function( data ) {
      $('#qvProductContent').html(data);
      openPopup('qvPopup');
//     $('#slider-for').slick({
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       arrows: true,
//       dots: false,
//       infinite: false,
//       fade: false,
//       asNavFor: "#thumbnail_slider"
//     });
//     $('#thumbnail_slider').slick({
//       slidesToShow: 5,
//       slidesToScroll: 1,
//       vertical: true,
//       slidesToScroll: 1,
//       asNavFor: "#slider-for",
//       arrows: true,
//       infinite: false,
//       focusOnSelect: true
//     });
      $('.openQv').removeAttr('disabled');
    });

  });
  $('.tranding-slider').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  function gridSlick(){ // image-grid.liquid
    if ($(window).width() <= 768){
      if(!$('.image-grid.mobile_scroll_true .grid-wrapper').hasClass('slick-initialized')){
        $('.image-grid.mobile_scroll_true .grid-wrapper').slick({
          arrows: false,
          dots: false,
          infinite: true,
          initialSlide: 0,
          slidesToScroll: 1,
          slidesToShow: 1
        });
      } else {
        if($('.image-grid.mobile_scroll_true .grid-wrapper').hasClass('slick-initialized')){
          $('.image-grid.mobile_scroll_true .grid-wrapper').slick('unslick');
        }
        gridSlick();
      }
    } else {
      if($('.image-grid.mobile_scroll_true .grid-wrapper').hasClass('slick-initialized')){
        $('.image-grid.mobile_scroll_true .grid-wrapper').slick('unslick');
      }
    }
  }
  gridSlick();
  $(window).on('resize', function(){
    gridSlick();
  }) // image-grid.liquid
  var yourNavigation = $(".main_header_new");
  stickyDiv = "sticky";
  yourHeader = $('.shopify-section-header').height();

  var add_to_cart = $('.product-detailSlider').height();
  if($('#AddToCart-product-template').length > 0 ){
    var distance = $('#AddToCart-product-template').offset().top;
  }

  // MENU TOP
  var top_bar_height = 0;
  if ($('#shopify-section-top-bar').length > 0){
    top_bar_height = parseInt($('#shopify-section-top-bar').height());  
  }
  var header_height = parseInt($('#shopify-section-header-new').height());
  var totalHeight = top_bar_height + header_height;
  function headerHeight(){
    if ($('.main_header_new').hasClass('sticky')){
      $('.mobile-nav').css('top',header_height+'px');
      $('.menu-overlay1').css('top',header_height+'px');
    } else {
      $('.mobile-nav').css('top',totalHeight+'px');
      $('.menu-overlay1').css('top',totalHeight+'px'); 
    }
  }
  headerHeight();
  
  $(window).scroll(function() {
  var scrollyourHeader = $('.main_header_new').height();
  var stickyheader = $('.ais-search-header').outerHeight();
  var total_header = scrollyourHeader + stickyheader;
  
    if( $(this).scrollTop() > yourHeader ) {
      yourNavigation.addClass(stickyDiv);
    } else {
      yourNavigation.removeClass(stickyDiv);
    }
    headerHeight();
    if($(window).width() < 768 ){
      if( $(this).scrollTop() > distance ) {
        $('.mob-sticky-btn').removeClass('u-hidden');
      } else {
        $('.mob-sticky-btn').addClass('u-hidden');
      }
      
      if( $(this).scrollTop() > yourHeader ) {
        $('.ais-view-wrap,.ais-facets').css('top',total_header);
      }
      else{
        $('.ais-view-wrap,.ais-facets').css('top','unset');
      }
      
    }else{
      if($('.sizeBtnbox').length > 0 ){
        var desk_distance = $('.sizeBtnbox').offset().top;
      }
      var sticky_height = $('.main_header_new').height();
      $('.desk_sticky_bar').css('top',sticky_height);
      if( $(this).scrollTop() > desk_distance+100 ) {
        $('.desk_sticky_bar').removeClass('u-hidden');
      } else {
        $('.desk_sticky_bar').addClass('u-hidden');
      }

    }
  });
  
  /*mobile-nav*/
  $('body').on('click', '.mobileNav',function(e){
    e.preventDefault();
    setTimeout(function(){
      $('body').addClass('menuOpen');
      $('.fullPage').addClass('witmenu');
    }, 100);
    });
  
  $('#mainNavMob ul').html($('#AccessibleNav').html());
//   if($(window).width() < 768) {
//     $('.col_only_text div#le-chat-header-dv-button').remove();
//   }
  $('.menu-overlay, div#LP_DIV_1505925578699').on('click', function(e){
    e.preventDefault();
    $('body').removeClass('menuOpen');
    $('.fullPage').removeClass('witmenu');
    $('body').removeClass('filterOpen');
    $('body').removeClass('cartOpen');
    $('#smallcart').removeClass('active-mini');
  });
  $('.menu-overlay-mini').on('click', function(e){
    e.preventDefault();
    $('body').removeClass('cartOpen');
    $('#smallcart').removeClass('active-mini');
    $('.cart-icon').focus();
  }); 
 
  $('header').on('click','.cart-icon:not(.cart-pg)',function(e){
    e.preventDefault();
    $('body').addClass('cartOpen');
    $('#smallcart').addClass('active-mini');
    opend_pop = $(this);
    setTimeout(function(){$('#mini-shopping-cart').focus()},500);
  });
  
   $('header').on('click','.cart-close',function(e){
    e.preventDefault();
    $('body').removeClass('cartOpen');
    $('#smallcart').removeClass('active-mini');
    opend_pop.focus();
  });
  
//   $('body').on('click','#AddToCart-product-template',function(e){
// //     $('body').addClass('cartOpen');
// //     $('#smallcart').addClass('active-mini');
//     pintrk('track', 'addtocart');
//   });
//   $('body').on('click','input.isp_quick_view_add_to_cart_btn_quick_view',function(e){
//     pintrk('track', 'addtocart');
//   });
  
  
  $('#mainNavMob').on('click','.toggleItem',function(e){
    $('.mobileMenu').addClass('mobfoxheight');
    $('.mobileMenu')[0].scrollTop = 0;
    if($(this).hasClass('opend')) {
      $('.toggleItem').removeClass('opend');
      $('.dropdownmenu').removeClass('toggleSubMenu');
    } else {
      $('.toggleItem').removeClass('opend');
      $('.dropdownmenu').removeClass('toggleSubMenu');
      $(this).addClass('opend');
      $(this).parent().next('ul').addClass('toggleSubMenu');
    }

  });
  $('#mainNavMob').on('click','.backTitle',function(e){
    $('.toggleItem').removeClass('opend');
    $('.dropdownmenu').addClass('hideToggleMenu');
    setTimeout(function(){
      $('.dropdownmenu').removeClass('toggleSubMenu').removeClass('hideToggleMenu');
    },500);
    $('.mobileMenu').removeClass('mobfoxheight');

    $('#mainNavMob').on('click','.col_menu_only .menu_only_title',function(e){
      var h = $(this).closest('ul')[0].scrollHeight;
      $(this).closest('ul')[0].scrollTop = 0;
      $(this).closest('ul').css('overflow','hidden');
      $(this).next('ul').addClass('menu_step3'); //.css('min-height',h+'px');

    });

    $('#mainNavMob').on('click','.backTitle3',function(e){
      var btn = $(this);
      btn.closest('.toggleSubMenu').removeAttr('style');
      btn.closest('ul').addClass('hidemenu_step3');
      setTimeout(function(){
        btn.closest('ul').removeClass('menu_step3').removeClass('hidemenu_step3');
      },500);
    });
  });
/**/
  function closePopup() {
    $('.popupOverlay').fadeOut('slow');
    //$('.cls_popup').remove();
    $('.editItem').removeClass('editting');
  }
  function openPopup(a) {
    $('.popupOverlay.'+a).fadeIn('slow');
    //$('.popupBox').append('');
  }

  window.onclick = function(e) {
    if ($(e.target).hasClass('popupOverlay')) {
      closePopup();
    }  
  }
  $('body').on('click','.cls_popup',function(e){
    e.preventDefault();
    closePopup();
  });
  $(document).keyup(function(e) {
    if (e.keyCode == 27) { 
      closePopup();
    }
  });

var add_mf = $('body').attr('data-money');
$('body').on('submit','form[action="/cart/add"]',function(e){
  e.preventDefault();
  $('.error').remove();
  var $addToCartForm = $(this);
  var $addToCartBtn = $addToCartForm.find('[type="submit"]');
  $addToCartBtn.text('Adding...');
  $addToCartBtn.addClass('disabled').prop('disabled', true);
  console.log($addToCartForm.serialize());
  // Add to cart.
  $.ajax({
    url: '/cart/add.js',
    dataType: 'json',
    type: 'post',
    data: $addToCartForm.serialize(),
    success: function(itemData) {
      // Re-enable add to cart button.
      $addToCartBtn.addClass('inverted');
      $addToCartBtn.text('Thank you!');
      
      setTimeout(function(){
        refresh_minicart();
        $addToCartBtn.prop('disabled', false).removeClass('disabled').removeClass('inverted');
        $addToCartBtn.text('Add to cart');
        $addToCartBtn.removeClass('disabled').prop('disabled', false);
        $("body").addClass("cartOpen");
        $("#smallcart").addClass("active-mini");
        setTimeout(function(){$('#mini-shopping-cart').focus()},500);
        $.getJSON('/cart.js', function(c){
          $('.mini-cart .cart-icon > span:not(.sr-only)').html(c.item_count);
        });
      },500);
      closePopup();
      
      var expectedShipDate = itemData.properties != null ? itemData.properties['EXPECTED SHIP DATE'] != null ? itemData.properties['EXPECTED SHIP DATE'] : '' : '';
      var size = itemData.variant_options.length > 1 ? itemData.variant_options[1].trim() : '';
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'addToCart',
        addToCartLocation: 'Product Page',
        product: {
          id: itemData.product_id,
          sku: itemData.variant_id,
          style: itemData.sku,
          name: itemData.title,
          price: (parseInt(itemData.final_price)/100).toFixed(2),
          basePrice: (parseInt(itemData.original_price)/100).toFixed(2),
          quantity: itemData.quantity,
          brand: itemData.vendor,			
          color: itemData.variant_options[0].trim(),
          colorFamily: itemData.variant_options[0].trim(),
          size: size,
          expectedShipDate: expectedShipDate
        },
        productRaw: JSON.parse($('#product_json').html())
      });
      setTimeout(function() {
        updateCartEvent(itemData, 'add', 1)
      }, 1000);
      cartUpsellitems();
    }, 
    error: function(XMLHttpRequest) {
      var response = $.parseJSON(XMLHttpRequest.responseText);
      $addToCartForm.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
      $addToCartBtn.text('Add To Cart');
      $addToCartBtn.removeClass('disabled').prop('disabled', false);
    }
  });
  opend_pop = $addToCartBtn
});
  $('body').on('click','.adjust' ,function(){
    var ip = parseInt($(this).parent().find('input').val());
    if($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      ip = 1;
    }
    $(this).parent().find('input').val(ip);
  });
  $("body").on('click', "a.remove_item", function(r){
    r.preventDefault();
    var id = $(this).data("id");
    var item = [];

    // BUNDLE PRODUCT REMOVE
    var updateData = {};
    var data_bundle_id = $(this).attr('data-bundle_id');
    if(data_bundle_id != ''){
      $('.remove_item[data-bundle_id="'+ data_bundle_id +'"]').each(function(ii,vv){
        updateData[$(vv).data('id')] = 0;
      });
    }else{
      updateData[$(this).data('id')] = 0;
    }
    // BUNDLE PRODUCT REMOVE
    
    $.getJSON('/cart.js', function(cart) {
      var c = $(cart.items).filter(function(index, cont) {                    
        return cont.id == id;
      });
      item.push(c[0]);
    });
    // Shopify.changeItem(id,0, function(c){
    //   $('.cart-icon span').text(c.item_count);
    //   if(!c.item_count) {
    //     // $('.mini-shopping-cart').empty();
    //     // $('.mini-shopping-cart').append('<div class="showOnSmall"><h3>YOUR CART</h3><a href="#" class="cart-close">x</a></div><div class="empty-page-content1 text-center"><p class="no-cart">You have no items in your shopping bag.</p></div>');
    //     $.get( "/cart?view=mini", function( data ) {
    //       // $('.mini-shopping-cart').html(data);
    //        var new_data = data.split('[cartsplit]');
    //        $('body .mini-shopping-cart .main-cart-dt-rep').html(new_data[0]);
    //        $('body .mini-shopping-cart .cart__subtotal').html(new_data[1]);
           
    //       if ($('#smallcart').find('.empty-page-content1').length == 0){
    //         $('footer.cart__footer').show();
    //       } else {
    //         $('footer.cart__footer').hide();
    //       }
    //     });
    //     $.getJSON("/cart.js", function(cart) {
    //       $('.cart-icon span').text(cart.item_count);
    //     });
    //   } else {
    //     $.get( "/cart?view=mini", function( data ) {
    //       // $('.mini-shopping-cart').html(data);
    //       var new_data = data.split('[cartsplit]');
    //        $('body .mini-shopping-cart .main-cart-dt-rep').html(new_data[0]);
    //        $('body .mini-shopping-cart .cart__subtotal').html(new_data[1]);
           
    //       if ($('#smallcart').find('.empty-page-content1').length == 0){
    //         $('footer.cart__footer').show();
    //       } else {
    //         $('footer.cart__footer').hide();
    //       }
    //       cartCollectionSlider();
    //       $.getJSON("/cart.js", function(cart) {
    //         $('.cart-icon span').text(cart.item_count);
    //       });
    //       setTimeout(function(){
    //         document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
    //       },500);
    //     });
    //   }
    // });
    $.ajax({
      type: "POST",
      dataType: "json",
      url: "/cart/update.js",
      data: {
        updates: updateData
      },
      async: false
    }).done(function(){
      $.get( "/cart?view=mini", function( data ) {
        var new_data = data.split('[cartsplit]');
         $('body .mini-shopping-cart .main-cart-dt-rep').html(new_data[0]);
         $('body .mini-shopping-cart .cart__subtotal').html(new_data[1]);
         
        if ($('#smallcart').find('.empty-page-content1').length == 0){
          $('footer.cart__footer').show();
        } else {
          $('footer.cart__footer').hide();
        }
        cartCollectionSlider();
        // ABTextRun();
        // ABBagdeTextRun();
        $.getJSON("/cart.js", function(cart) {
          $('.mini-cart .cart-icon > span:not(.sr-only)').html(cart.item_count);
        });
        setTimeout(function(){
          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
        },500);
        
        var GWPEle = new_data[2];
        addFreeGiftProduct('remove', GWPEle);
      });
    });
    setTimeout(function() {
      updateCartEvent(item[0], 'remove')
    }, 1000);
    $.getJSON("/cart.js", function(cart) {
      $('.mini-cart .cart-icon > span:not(.sr-only)').html(cart.item_count);
    });
  });

  $('body').on("click", ".cart__remove", function(e) {
    e.preventDefault();
    var id = $(this).data('id');  
    var item = [];

    // BUNDLE PRODUCT REMOVE
    var updateData = {};
    var data_bundle_id = $(this).parents('.item-body').attr('data-bundle_id');
    if(data_bundle_id != ''){
      $('.item-body[data-bundle_id="'+ data_bundle_id +'"]').each(function(ii,vv){
        updateData[$(vv).data('id')] = 0;
      });
    }else{
      updateData[$(this).data('id')] = 0;
    }
    // BUNDLE PRODUCT REMOVE
    
    $.getJSON('/cart.js', function(cart) {
      var c = $(cart.items).filter(function(index, cont) {                    
        return cont.id == id;
      });
      item.push(c[0]);
    });  
    $.ajax({
      type: "POST",
      dataType: "json",
      url: "/cart/update.js",
      // data: "updates["+id+"]=0",
      data: {
        updates: updateData
      },
      async: false
    }).done(function(){
      $.get( "/cart", function( data ) {
        $('.cartItemData').html($(data).find('.cartItemData').html());
        // ABTextRun();
        // ABBagdeTextRun();
        shoppingGivesWidget();
        addFreeGiftProduct('remove', $(data).find('.ShoppingCntr').data('gwp_eligible'));
      });
      $.getJSON("/cart.js", function(cart) {
        $('.mini-cart .cart-icon > span:not(.sr-only)').html(cart.item_count);
      });
      setTimeout(function() {
        updateCartEvent(item[0], 'remove')
      }, 1000);
    });
  });

  $('body').on('change','.multiPro :radio', function() {
    var optionIndex = jQuery(this).closest('.multiPro').attr('data-option-index');
    var optionValue = jQuery(this).val();
    $(this)
    .closest('form')
    .find('.single-option-selector')
    .eq(optionIndex)
    .val(optionValue)
    .trigger('change');
  });

  $("body").on('click', "a.editItem", function(e){
    e.preventDefault();
    $('.editItem').removeClass('editting');
    var proHandle = $(this).attr('data-handle');
    var q = $(this).attr('data-val');
    $(this).addClass('editting');
    $.get( "/products/"+proHandle+"?view=editor", function( data ) {
      $('.editItemContainer').html(data);
      $('.editorProduct .quantity').val(q);
      openPopup('editItemContainer');
    });
  });

  // select donation cause 
  $('body').on('click', '.sg-featured-select.sg-select-button',function(){
    if ($('#sg-custom-widgets-container').find('.main-element.sg-campaign-active').length > 1){
        $('#sg-custom-widgets-container').find('.main-element.sg-campaign-active').each(function(index, val){
            if($(val).find('.select-text.sg-open-charity-select').text() == 'Select Cause'){
              $(val).closest('.sg-widget').remove();
            }
        });
    }
  });
    
   $('body').on('click', '.adjust1',function(e){
    var ip = parseInt($(this).parent().find('input').val());
    var event = '', _thisClass = '';
    
    this_ele = $(this).parents('.data-cart_item').data('id');
    
    if($(this).hasClass('qty-add')) {
      ip = ip + 1;
      event = 'add';
      _thisClass = '.qty-add';
    } else {
      ip = ip - 1;
      event = 'remove';
      _thisClass = '.qty-minus';
    }
    if(ip==0) {
      return false;
    }
    $(this).parent().find('input').val(ip);
    var id = parseInt($(this).parent().find('input').attr('data-id'));
    var atcLocation = '';
    
    if ($(this).parents('.mini-shopping-cart').length != 0){
      atcLocation = 'Mini-Cart'
    } else if ($(this).parents('.cartItemData').length != 0){
      atcLocation = 'Cart Page'
    }
    var item = [];
    $.getJSON('/cart.js', function(cart) {
      var c = $(cart.items).filter(function(index, cont) {                    
        return cont.id == id;
      });
      item.push(c[0]);
    });
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+id+']='+ip,
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        // $('#crt').removeClass('loading');
      }
    }).done(function( data ) {
      $.get( "/cart", function( data ) {
        $('.cartItemData').html($(data).find('.cartItemData').html());
        shoppingGivesWidget();
        // ABTextRun();
        // ABBagdeTextRun();
        $('.data-cart_item[data-id="'+ this_ele +'"]').find(_thisClass).focus();
        addFreeGiftProduct('update', $(data).find('.ShoppingCntr').data('gwp_eligible'));
      });
      $.get( "/cart?view=mini", function( data ) {
        // $('.mini-shopping-cart').html(data);
        var new_data = data.split('[cartsplit]');
         $('body .mini-shopping-cart .main-cart-dt-rep').html(new_data[0]);
         $('body .mini-shopping-cart .cart__subtotal').html(new_data[1]);
         
        if ($('#smallcart').find('.empty-page-content1').length == 0){
          $('footer.cart__footer').show();
        } else {
          $('footer.cart__footer').hide();
        }
        cartCollectionSlider();
        // ABTextRun();
        // ABBagdeTextRun();

        $('.data-cart_item[data-id="'+ this_ele +'"]').find(_thisClass).focus();
        
        var GWPEle = new_data[2];
        addFreeGiftProduct('update', GWPEle);
        
        $.getJSON("/cart.js", function(cart) {
          $('.mini-cart .cart-icon > span:not(.sr-only)').html(cart.item_count);
        });
        setTimeout(function(){
          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
        },500);
        
      });
      for (var i = 0 ; i < data.items.length; i++){
        if (data.items[i].id == id){
          var itemdata = data.items[i];
          break;
        }
      }
      // var expectedShipDate = itemdata.properties != null ? itemdata.properties['EXPECTED SHIP DATE'] != null ? itemdata.properties['EXPECTED SHIP DATE'] : '' : '';
      // var size = itemdata.variant_options.length > 1 ? itemdata.variant_options[1].trim() : '';
      // window.dataLayer = window.dataLayer || [];
      // window.dataLayer.push({
      //   event: 'addToCart',
      //   addToCartLocation: atcLocation,
      //   product: {
      //     id: itemdata.product_id,
      //     sku: itemdata.variant_id,
      //     style: itemdata.sku,
      //     name: itemdata.title,
      //     price: (parseInt(itemdata.final_price)/100).toFixed(2),
      //     basePrice: (parseInt(data.original_price)/100).toFixed(2),
      //     quantity: itemdata.quantity,
      //     brand: itemdata.vendor,			
      //     color: itemdata.variant_options[0].trim(),
      //     colorFamily: itemdata.variant_options[0].trim(),
      //     size: size,
      //     expectedShipDate: expectedShipDate
      //   },
      //   productRaw: JSON.parse($('#product_json-'+id).html())
      // });
      setTimeout(function() {
        updateCartEvent(item[0], event, 1)
      }, 1000);
    });

  });
  $("body").on('click', ".addToCartEdit", function(e){
    e.preventDefault();
    var btn = $(this);
    var form = $(this).closest('form');
    var oldbtntext = btn.val();
    btn.attr('disabled', 'disabled');
    btn.val('Updating...');
    var newItemID = form.find('[name="id"]').val();
    var newItemQty = parseInt(form.find('[name="quantity"]').val());
    var oldItemID = $('.editting').attr('data-lineid');
    if(newItemQty==0) {
      newItemQty = 1;
      form.find('[name="quantity"]').val(1);
    }
    if(newItemID == oldItemID) {
      var oldQty = newItemQty;
    } else {
      var oldQty = 0;
    }
    form.find('.error').remove();
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: "updates["+newItemID+"]="+newItemQty+"&updates["+oldItemID+"]="+oldQty,
      dataType: 'json',
      success: function(item) {
        $.get( "/cart?view=full", function( data ) {
          closePopup(); 
          $('.cartItemData').html(data);
          if (window.Shopify && Shopify.StorefrontExpressButtons) {
            Shopify.StorefrontExpressButtons.initialize();
          }
        });
        
        var fromMini = 0;
        if($('.mini-shopping-cart .editting').length) {
          fromMini = 1;
        }
        $.get( "/cart?view=mini", function( data ) {
          // $('.mini-shopping-cart').html(data);
          var new_data = data.split('[cartsplit]');
           $('body .mini-shopping-cart .main-cart-dt-rep').html(new_data[0]);
           $('body .mini-shopping-cart .cart__subtotal').html(new_data[1]);
           
          if ($('#smallcart').find('.empty-page-content1').length == 0){
            $('footer.cart__footer').show();
          } else {
            $('footer.cart__footer').hide();
          }
          cartCollectionSlider();
          // ABTextRun();
          // ABBagdeTextRun();
          
          var GWPEle = new_data[2];
          addFreeGiftProduct('add', GWPEle);
          
          if(fromMini) {
            //$('.mini-shopping-cart').show();
            $('#smallcart').addClass('tempShow');
            setTimeout(function(){
              $('#smallcart').removeClass('tempShow');
            },5000);
          }
        });

        $.getJSON('/cart.js', function(c){
          $('.cart-count').text(c.item_count);
        });
        
        btn.val(oldbtntext);
        btn.removeAttr('disabled');
        $('.editItem').removeClass('editting');
        
      },
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        if($(window).width() < 768) {
          form.find('.cartMsg').remove();
          var h = '<div class="popupOverlay cartMsg">';
          h += '<div class="popupBox slideInDown animated">';
          h += '<h4>Opps !</h4>';
          h += '<div class="poupbody">';
          h += '<h3>'+response.description+'</h3>';
          h += '</div>';
          h += '<div class="popupbtns">';
          h += '<a href="#" class="btn closepopup" >Continue Shopping</a>';
          h += '</div>';
          h += '</div>';
          h += '</div>';
          form.append(h);
          openPopup('cartMsg');
        }
        btn.val(oldbtntext);
        btn.removeAttr('disabled');
      }      
    });
  });
//   $( "li.search" ).hover(function() {
//     $(this).addClass('cont');
//   });
//   window.onclick = function(e) {
//     if (!$(e.target).closest('.cont').length || !$(e.target).closest('.ui-autocomplete.ui-front.ui-menu.ui-widget.ui-widget-contentx.ui-corner-all').length){
//       $('li.search').removeClass('cont');
//     }  
//   }
//   $('#mainNavDesk li:not(.search)').hover(function() {
//     $('#mainNavDesk li').removeClass('cont');
//   });
//   $('.toggleSearch').on('click', function(e){
//     e.preventDefault();
//     if($('.mobile-nav').is(':visible')){
//       $('body').removeClass('menu-open');
//       $(".mobile-nav").css("transform", "translate(-100%, 0)");
//     }
//     $('.toggleSearchBox').slideToggle();
//   });
  

  // rebooted start
	var rmf = $('body').attr('data-money');
  $('body').on('click','.rebooted_grid .rebooted_grid_link, .rebooted_grid .img_wrpr img,.rebootedcnt_wrpr p,.rebootedcnt_wrpr span',function(e){
    e.preventDefault();
    $('.preproperties').remove();
    var variant_price = Number($(this).closest('.rebooted_grid').attr('data-variant_price')), 
        cmp_variant_price = Number($(this).closest('.rebooted_grid').attr('data-cmp_price')),
        variant_title = $(this).closest('.rebooted_grid').attr('data-var_title'),
        pro_title = $(this).closest('.rebooted_grid').attr('data-var_title'),
        popup_data = '',
        is_pre_order = $(this).closest('.rebooted_grid').attr('data-preorder'),
        is_back_order = $(this).closest('.rebooted_grid').attr('data-is_backorder'),
        pdatemeta = $(this).closest('.rebooted_grid').attr('data-variant_order_date'),
        img_urls = $(this).closest('.rebooted_grid').attr('data-images-url'),
        new_variant_id = $(this).closest('.rebooted_grid').attr('data-varaint-id'),
        button_text = 'Add To Cart';
    if(is_pre_order == 'true'){
      var preOrderdate = new Date();
      preOrderdate.setDate(preOrderdate.getDate() + 45);
      var curr_date = preOrderdate.getDate();
      var curr_month = preOrderdate.getMonth();
      curr_month++;
      var curr_year = preOrderdate.getFullYear();
      if(pdatemeta==null || pdatemeta==''){
        pdatemeta=curr_month + "/" + curr_date + "/" + curr_year;
      }
      if(is_back_order == 'true'){
        button_text = 'Back-Order';
        $('.rebooted_atc_form').append('<div class="preproperties"> <input type="hidden" value='+pdatemeta+' name="properties[EXPECTED SHIP DATE]"/> <input type="hidden" value="1" name="properties[Back-ordered items]" /></div>');
      }else{
        button_text = 'Pre-Order';
        $('.rebooted_atc_form').append('<div class="preproperties"> <input type="hidden" value='+pdatemeta+' name="properties[EXPECTED SHIP DATE]"/> <input type="hidden" value="1" name="properties[PRE-ORDERED ITEMS]" /></div>');
      }
    }
    $('.rebooted_popup_parent .rebooted_atc_btn').val(button_text).attr('data-lable',button_text);

    if($('.rebooted_popup_parent .left_side_bar.slick-initialized').length){
      $('.rebooted_popup_parent .left_side_bar').slick('unslick');
    }
    $('.rebooted_popup_parent .left_side_bar').empty();


    $('.type_p').hide();
    $('.rebooted_popup').addClass('active');

//     if(img_urls == "true" ){
//       if(all_imgs_pdp_slider[new_variant_id].length > 0 ){
//         $.each(all_imgs_pdp_slider[new_variant_id], function(ii,vv){
//           popup_data += '<div class="img_wrpr"> <img class="mainImg" src="'+ vv + '" data-img="'+ vv + '" alt="'+ pro_title +'"/></div>';
//         });
//       }	
//     }
//     else{
//       if(all_imgs_pdp.length > 0 ){
//         $.each(all_imgs_pdp, function(ii,vv){
//           popup_data += '<div class="img_wrpr"> <img class="mainImg" src="'+ vv + '" data-img="'+ vv + '" alt="'+ pro_title +'"/></div>';
//         });
//       }
//       if(all_video_pdp.length > 0 ){
//         $.each(all_video_pdp,function(ii,vv){
//           popup_data += '<div class="img_wrpr">'+ vv +'</div>';
//         });
//       }
//       if(all_media_pdp.length > 0 ){
//         $.each(all_media_pdp,function(ii,vv){
//           popup_data += '<div class="img_wrpr">'+ vv +'</div>';
//         });
//       }
//     }
    if(typeof all_imgs_pdp !== 'undefined' && typeof all_imgs_pdp[variant_title] !== 'undefined'){
      if(all_imgs_pdp[variant_title].length){
        $(all_imgs_pdp[variant_title]).each(function(ii,vv){
          popup_data += '<div class="img_wrpr"> <img class="mainImg" src="'+ vv + '" data-img="'+ vv + '" alt="'+ variant_title +'"/></div>';
        });
      }
    }
    if(typeof all_video_pdp !== 'undefined' && typeof all_video_pdp[variant_title] !== 'undefined'){
      if(all_video_pdp[variant_title].length){
        $(all_video_pdp[variant_title]).each(function(ii,vv){
          popup_data += '<div class="img_wrpr">'+ vv +'</div>';
        });
      }
    }
    if(typeof all_media_pdp !== 'undefined' && typeof all_media_pdp[variant_title] !== 'undefined'){
      if(all_media_pdp[variant_title].length){
        $(all_media_pdp[variant_title]).each(function(ii,vv){
          popup_data += '<div class="img_wrpr">'+ vv +'</div>';
        });
      }
    }
    //     $('.productImges .featuredSlide[data-get_alt="'+ variant_title +'"]').each(function(i,v){
    //       if($(v).find('a').length){
    //         popup_data += '<div class="img_wrpr">'+ $(v).find('a').html() +'</div>';
    //       }else{
    //         popup_data += '<div class="img_wrpr">'+ $(v).html() +'</div>';
    //       }
    //     });
    if(popup_data == ''){
      if($('.productImges .featuredSlide').first().find('a').length){
        popup_data += '<div class="img_wrpr">'+ $('.productImges .featuredSlide').first().find('a').html() +'</div>';
      }else{
        popup_data += '<div class="img_wrpr">'+ $('.productImges .featuredSlide').first().html() +'</div>';
      }
    }
    $('.rebooted_popup_parent .left_side_bar').append(popup_data);
    $('.rebooted_popup_parent .left_side_bar').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      dots: true
    });

    $('.rebooted_popup_wrpr [name="id"]').val($(this).closest('.rebooted_grid').find('[name="id"]').val());
    if(cmp_variant_price > variant_price){
      $('.rebooted_popup_wrpr .price_text').html('<del>'+ Shopify.formatMoney(cmp_variant_price, rmf) +'</del>' + Shopify.formatMoney(variant_price, rmf));
    }else{
      $('.rebooted_popup_wrpr .price_text').html(Shopify.formatMoney(variant_price, rmf));
    }
    $('.type_p.price').show();
    if($(this).closest('.rebooted_grid').attr('data-condition') != ''){
      $('.rebooted_popup_wrpr .condition_text').html($(this).closest('.rebooted_grid').attr('data-condition'));
      $('.type_p.condition').show();
    }
    if($(this).closest('.rebooted_grid').attr('data-size_name') != ''){
      $('.rebooted_popup_wrpr .size_text').html($(this).closest('.rebooted_grid').attr('data-size_name'));
      $('.type_p.size').show();
    }
    if($(this).closest('.rebooted_grid').attr('data-color_name') != ''){
      $('.rebooted_popup_wrpr .color_text').html($(this).closest('.rebooted_grid').attr('data-color_name'));
      $('.type_p.color').show();
    }
    if($(this).closest('.rebooted_grid').attr('data-product_descripotion') != ''){
      $('.rebooted_popup_wrpr .rebooted_desc').html($(this).closest('.rebooted_grid').attr('data-product_descripotion'));
      $('.type_p.is_reboot_desc').show();
    }

    if(jQuery('.rebooted_popup_parent .left_side_bar.slick-initialized').length){
      jQuery('.rebooted_popup_parent .left_side_bar').slick('refresh');
    }
  });

  jQuery('.rebootedimg_wrpr.set_slide').slick({
    dots: false,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          dots: true,
          arrows: false
        }
      }
    ]
  });
$('body').on('click','.rebooted_atc_btn',function(e){
  e.preventDefault();
  var btn = $(this);
  var form = $(this).closest('form');
  btn.attr('disabled', 'disabled');
  btn.val('Adding');
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: form.serialize(),
    dataType: 'json',
    error: function(jqXHR, textStatus, errorThrown){
      var response = $.parseJSON(jqXHR.responseText);
      form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
      btn.text('Add To Cart');
      btn.removeAttr('disabled');
    }
  }).done(function( data ) {
    opend_pop = btn;
    btn.val('Thank You!');
    $.get( "/cart?view=mini", function( data ) {
      // $('.mini-shopping-cart').html(data);
      var new_data = data.split('[cartsplit]');
       $('body .mini-shopping-cart .main-cart-dt-rep').html(new_data[0]);
       $('body .mini-shopping-cart .cart__subtotal').html(new_data[1]);
       
      if ($('#smallcart').find('.empty-page-content1').length == 0){
        $('footer.cart__footer').show();
      } else {
        $('footer.cart__footer').hide();
      }
      cartCollectionSlider();
      // ABTextRun();
      // ABBagdeTextRun();
      
      var GWPEle = new_data[2];
      addFreeGiftProduct('add', GWPEle);
    });
    $.getJSON('/cart.js', function(c){
       $('.mini-cart .cart-icon > span:not(.sr-only)').html(c.item_count);
    });
    setTimeout(function(){
      btn.val('Add To Cart');
    },500);
    if($('.rebooted_popup').hasClass('active')){
      $('.rebooted_popup').removeClass('active');
    }
    setTimeout(function(){
      btn.removeAttr('disabled');
      $("body").addClass("cartOpen");
      $("#smallcart").addClass("active-mini");
    },1000);
    setTimeout(function(){$('#mini-shopping-cart').focus()},1500);
    var expectedShipDate = data.properties != null ? data.properties['EXPECTED SHIP DATE'] != null ? data.properties['EXPECTED SHIP DATE'] : '' : '';
    var size = data.variant_options.length > 1 ? data.variant_options[1].trim() : '';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'addToCart',
      addToCartLocation: 'Re-vita Product Page',
      product: {
        id: data.product_id,
        sku: data.variant_id,
        style: data.sku,
        name: data.title,
        price: (parseInt(data.final_price)/100).toFixed(2),
        basePrice: (parseInt(data.original_price)/100).toFixed(2),
        quantity: data.quantity,
        brand: data.vendor,			
        color: data.variant_options[0].trim(),
        colorFamily: data.variant_options[0].trim(),
        size: size,
        expectedShipDate: expectedShipDate
      },
      productRaw: JSON.parse($('#product_json').html())
    });
    setTimeout(function() {
      updateCartEvent(data, 'add', 1)
    }, 1000)
    cartUpsellitems();
  });

});
$('body').on('click','.rebooted_popup_parent .close-icon, .continue_shop_reboot', function(e){
  jQuery('.rebooted_popup').removeClass('active');
});
  // $('.sticky_select_box').change(function(){
//   var data= $(this).val();
//   $('#ProductSelect-product-template-option-1').val(data).trigger('change');
// });
  $('body').on('change','select.custom_swatch.custome-select',function(e) {
    $('.new_custom_swatch_size').find('.swatch-element[data-value="'+$(this).val()+'"] input').trigger('click');
  });
$('body').on('click','.sticky_add_cta_button',function(e){
	e.preventDefault();
  $('.product-form__cart-submit').trigger('click');
});
$('body').on('click','.mob_sticky_add_cta_button',function(e){
	e.preventDefault();
  if($('#ProductSelect-product-template-option-1').val() != ''){
    $('.product-form__cart-submit').trigger('click');	
  }else{
    $('html, body').animate({
      scrollTop: $(".sizeBtnbox").offset().top
    }, 1000);
  }
  
});
  // rebooted end
//FAQ ACCORDIAN
$(".set > a").on("click", function () {
  if ($(this).hasClass("active")) {
    $(this).removeClass("active");
    $(this).siblings(".content").slideUp(200); 
  } else { 
    $(".set > a").removeClass("active");
    $(this).addClass("active");
    $(".content").slideUp(200);
    $(this).siblings(".content").slideDown(200);
  }
}); 
$('.main-collection-slider').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 414,
      settings: {
        slidesToShow: 2,
        slidesToScroll:1
      }
    }
  ]
});
  // Algolia JS Start
  $('body').on('click','.ais-page .ais-Hits-item .quick_view_sizes .swatch-element',function(e){
  e.preventDefault();
  $('.pro_size_error').remove();
  var v_id = $(this).attr('data-variant-fbid');
  var p_handle = $(this).attr('data-product');
  var attr = $(this).attr('data-pre-order_date');
  var atcLocation = 'Collection-page';
    
  var datap = [];
  var items = {},prop = {};
  
  items.id = v_id;
  items.quantity = 1;
  if (typeof attr !== 'undefined' && attr !== false) {
    if($(this).attr('data-pre-order_date').length > -1 ){
        prop['EXPECTED TO SHIP'] = attr;
        prop['PRE-ORDERED ITEMS'] = '1';
       items.properties = prop;
    }
  }
    
  datap.push(items);
  opend_pop = $(this).find('label');
    
  if($(this).attr('data-avaiable') == 'false'){
  $.get('/products/'+p_handle+'?view=back-in-stock&variant='+v_id,function(coll_data){
    $('.fallback-BIS-container').html(coll_data);
    $('.fallback-BIS-container').addClass('bis-popup-opened');
    $('body').addClass('bis-body-popup-opened');
    setTimeout(function(){$('#fallback-BIS-wrap').focus()},500);
  });
  }else{
  // Add to cart.
  $.ajax({
    url: '/cart/add.js',
    dataType: 'json',
    type: 'post',
    data: datap[0],
    success: function(itemData) {
      // Re-enable add to cart button.
      setTimeout(function(){
        refresh_minicart();
        $("body").addClass("cartOpen");
        $("#smallcart").addClass("active-mini");
        $.getJSON('/cart.js', function(c){
          $('.mini-cart .cart-icon > span:not(.sr-only)').html(c.item_count);
        });
      },500);
      setTimeout(function(){$('#mini-shopping-cart').focus()},700);

      var expectedShipDate = itemData.properties != null ? itemData.properties['EXPECTED SHIP DATE'] != null ? itemData.properties['EXPECTED SHIP DATE'] : '' : '';
      var size = itemData.variant_options.length > 1 ? itemData.variant_options[1].trim() : '';
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'addToCart',
        addToCartLocation: atcLocation,
        product: {
          id: itemData.product_id,
          sku: itemData.variant_id,
          style: itemData.sku,
          name: itemData.title,
          price: (parseInt(itemData.final_price)/100).toFixed(2),
          basePrice: (parseInt(itemData.original_price)/100).toFixed(2),
          quantity: itemData.quantity,
          brand: itemData.vendor,			
          color: itemData.variant_options[0].trim(),
          colorFamily: itemData.variant_options[0].trim(),
          size: size,
          expectedShipDate: expectedShipDate
        },
        productRaw: JSON.parse($('#product_json-'+p_handle).html())
      });
      setTimeout(function() {
        updateCartEvent(itemData, 'add', 1)
      }, 1000)
      cartUpsellitems();
    },
    error: function(XMLHttpRequest) {
      $(this).parent().append('<p class="pro_size_error">This size is no availabel.</p>')
    }
  });
  }
});
$('body').on('click','.ais-page .ais-Hits-item .quick_add_btn',function(e){
        e.preventDefault();
    var ___this = $(this);
    $(this).parents('.ais-hit--details').addClass('quick_view_opened');
    $(this).parents('.ais-hit--details').find('.quick_view_size_wp').show('fast', function(){
      $(this).parents('.ais-hit--details').find('.details_left_content_wp').hide('fast');
    });
  setTimeout(function(){___this.parents('.ais-hit--details').find('.swatch-element.size:first label').focus()},500);
  opend_pop = ___this;
});
$('body').on('click','.ais-page .ais-Hits-item .quick_close_btn',function(e){
        e.preventDefault();
  var ___this = $(this);
  $(this).parents('.ais-hit--details').removeClass('quick_view_opened');
  $(this).parents('.ais-hit--details').find('.details_left_content_wp').show('fast', function(){
    $(this).parents('.ais-hit--details').find('.quick_view_size_wp').hide('fast');
  });
  setTimeout(function(){opend_pop.focus()},500);
});
$('body').on('click','.ais-page .ais-Hits-item .swatch_wrap .swatch-element',function(e){
        e.preventDefault();
  var __this = $(this);
  var handle = $(this).attr('data-handle');
  $(this).parents('.swatch_wrap').find('.swatch-element').removeClass('custom_current_one_color');
  $(this).addClass('custom_current_one_color');
  $.get( '/products/'+ handle +'?view=product-card', function( data ) {
    var new_data = data.split('[prosplit]');
    __this.parents('.ais-Hits-item').find('.product_slider_img').html(new_data[0]);
    __this.parents('.ais-Hits-item').find('.ais-hit--title a').attr('href',new_data[2]).text(new_data[1]);
    __this.parents('.ais-Hits-item').find('.ais-hit--price').html(new_data[3]);
    __this.parents('.ais-Hits-item').find('.quick_view_sizes').html(new_data[4]);

    __this.parents('.ais-Hits-item').find('.quick_view_sizes').find('input:checked').removeAttr('checked');
    
    if (__this.parents('.ais-Hits-item').find('.ais-hit--promo-message')){
      __this.parents('.ais-Hits-item').find('.ais-hit--promo-message').html(new_data[9]);
    } else {
      __this.parents('.ais-Hits-item').find('.swatch_wrap').append('<div class="ais-hit--promo-message">'+new_data[9]+'</div>');
    }
    // ABTextRun();
    // ABBagdeTextRun();
  }).error(function(event, jqxhr, exception) {
  });
});
  $('body').on('click','.ais-RefinementList-showMore',function(e){
    e.preventDefault();
    if ($(this).text() == 'Show more' ){
      $(this).html('+ Show more');
    }
    else {
      $(this).html('- Show less');
    }
  })
});
$('body').on('click','.desktop_filter_btn ',function(e){
  if ($('.ais-RefinementList-showMore').length != -1 ){
    $('.ais-RefinementList-showMore').html('+ Show more');
  }
  // Algolia JS End
});
$(window).on('load',function(){
  $('#isp_custom_price_max').attr("placeholder", "300");
  $('#isp_custom_price_min').attr("placeholder", "0");
});


if($(window).width()<=767){
  $(document).ready(function() {
    $('.cart_product').slick({
      infinite: false,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  });
}
$(window).on('resize',function(){
  $('.product-slider').slick('refresh');
  // $('.product-slider').slick({	
  //   infinite: false,	
  //   slidesToShow: 1,	
  //   slidesToScroll: 1,	
  //   arrows: false,	
  //   dots: true	
  // });
});


$(document).ready(function() {
  $('.new_desktop_thumb_slider').slick({
    slidesToShow: 4,
    slidesToScroll: 2,
    dots: false,
    focusOnSelect: true,
    infinite: false,
    draggable: true,
    arrows: true
  });
  $('.product-slider').slick({	
    infinite: false,	
    slidesToShow: 1,	
    slidesToScroll: 1,	
    arrows: false,	
    dots: true	
  });
});

if($('body').hasClass('template-product')){
  function select_rec(){
    if($('.selector-wrapper').length > 0 ){
      $('.custome-select').each(function(){
        var $this = $(this), numberOfOptions = $(this).children('option').length;
        $this.addClass('select-hidden'); 
        $this.wrap('<div class="custome-select-wrapper"></div>');
        $this.after('<div class="select-styled"></div>');
        var $styledSelect = $this.next('div.select-styled');
        $styledSelect.text($this.children('option').eq(0).text());
        var $list = $('<ul />', {
          'class': 'select-options'
        }).insertAfter($styledSelect);
        for (var i = 0; i < numberOfOptions; i++) {
          if(i==0){
            //           $list.append('<li value="'+$this.children('option').eq(i).val()+'" data-value="'+$this.children('option').eq(i).attr('data-value')+'" data-stock="'+$this.children('option').eq(i).attr('data-stock')+'">'+$this.children('option').eq(i).attr('data-html')+'</li>')	
          }else{
            $list.append('<li value="'+$this.children('option').eq(i).val()+'" data-value="'+$this.children('option').eq(i).attr('data-value')+'" data-stock="'+$this.children('option').eq(i).attr('data-stock')+'">'+$this.children('option').eq(i).attr('data-html')+'</li>')
          }
        }
        var $listItems = $list.children('li');
        $styledSelect.click(function(e) {
          e.stopPropagation();
          $('div.select-styled.active').not(this).each(function(){
            $(this).removeClass('active').next('ul.select-options').hide();
          });
          $(this).toggleClass('active').next('ul.select-options').toggle();
        });
        $listItems.click(function(e) {
          if($(this).attr('value') != '' ){
            $('.select-styled').text($(this).attr('value')).removeClass('active');
          }else{
            $('.select-styled').text($(this).attr('data-value')).removeClass('active');
          }
          $this.val($(this).attr('value')).prop("selected", 1).trigger("change");
          $list.hide();
        });
        $(document).click(function() {
          $styledSelect.removeClass('active');
          $list.hide();
        });
      });
    }else{
      setTimeout(function(){
        select_rec();
      },1000);
    }
  }

  select_rec();
}
// Fallback Preview LP Start
$('body').on('click','.fallback-preview-lp-pro-grid:not(.love-for-lemon-grid) .quick_add_btn:not(.quick_add)',function(e){
	e.preventDefault();
    var ___this = $(this);
  
    $(this).parents('.ais-hit--details').addClass('quick_view_opened');
    $(this).parents('.ais-hit--details').find('.quick_view_size_wp').show('fast', function(){
      $(this).parents('.ais-hit--details').find('.details_left_content_wp').hide('fast');
    });
  
  setTimeout(function(){___this.parents('.ais-hit--details').find('.swatch-element.size:first label').focus()},500);
  opend_pop = ___this;
});

/* 27-04-23 Start dv-love-for-lemons */
$('body').on('click','.dv-love-for-lemons-featured-wrapper .fallback-preview-lp-pro-grid .quick_add_btn:not(.quick_add)',function(e){
  if ($(window).width() > 767){
    e.preventDefault();
    var ___this = $(this);
    var handle = ___this.parents('.love-for-lemon-grid').find('.swatch-element.custom_current_one_color').data('handle');
    
    $.get( '/products/'+ handle +'?view=product-card', function( data ) {
      var new_data = data.split('[prosplit]');
      ___this.parents('.fallback-preview-lp-pro-item').find('.product_slider_img').html(new_data[0]);
    })
    
    $(this).parents('.grid-wrapper').find('.ais-hit--details').addClass('quick_view_opened');
    $(this).parents('.grid-wrapper').find('.quick_view_size_wp').show('fast');
      
    setTimeout(function(){___this.parents('.ais-hit--details').find('.swatch-element.size:first label').focus()},500);
    opend_pop = ___this;
  }
});

$('body').on('click','.love-for-lemon-grid .quick_close_btn',function(e){
  e.preventDefault();
  var __this = $(this);
  $.get(window.location.href, function(data){
   var img_html = $(data).find('.love-for-lemon-grid-'+__this.data('block-id')).find('.product_slider_img').html();
    __this.parents('.fallback-preview-lp-pro-item').find('.product_slider_img').html(img_html);
  })
  $(this).parents('.ais-hit--details').removeClass('quick_view_opened');
  $(this).parents('.ais-hit--details').find('.quick_view_size_wp').hide('fast');
  setTimeout(function(){opend_pop.focus()},500);
});

$('#dv-love-for-lemon-pswd-sub').on('click',function(e){
  e.preventDefault();
  var _this = $(this), x = true;
  $('.dv-lemon-error').remove();
  var pswd = _this.parents('.lemon-pswd-form').find('#dv-love-for-lemon-pswd');
  
  if ($.trim(pswd.val()) == null || $.trim(pswd.val()) == ""){
    _this.parents('.lemon-pswd-form').append('<p class="error err dv-lemon-error">Password can\'t be blank.</p>');
    window.dataLayer.push({
      event: "enter_password_error",
      error_message: "Password can\'t be blank."
    });
    x = false;
  }

  if(x==true){
    var pswd = btoa($.trim(pswd.val()));
    if (pswd === $('body').data('cred')){
      $('.dv-love-for-lemon-pswd-wrap').fadeOut('fast');
      setTimeout(function(){
        $('main#main-content').css('display','block');
      },100)
      setCookie('dv-love-lemon-cookie',true, 7);
      window.dataLayer.push({
        event: "enter_password_success"
      });
      setTimeout(function(){
        if (window.LemonfeaturedCollectionDatalayer.length != 0 || window.LemonfeaturedCollectionDatalayer != undefined){
            window.dataLayer.push({
                event: "product list displayed",
                productList: {
                    name: "Your new favorite summer shoes - DV-x-for-love-lemons",
                    products: window.LemonfeaturedCollectionDatalayer,
                },
                _clear: true,
            });
          }
        if (window.featuredCollectionDatalayer.length != 0 || window.featuredCollectionDatalayer != undefined){
          window.dataLayer.push({
              event: "product list displayed",
              productList: {
                  name: "Shop the perfect summer shoes- DV-x-for-love-lemons",
                  products: window.featuredCollectionDatalayer,
              },
              _clear: true,
          });
        }
        console.log('Datalayer:',window.dataLayer);
      }, 1000);
    } else {
      _this.parents('.lemon-pswd-form').append('<p class="error err dv-lemon-error">Incorrect Password. Please try again.</p>');
      window.dataLayer.push({
        event: "enter_password_error",
        error_message: "Incorrect Password. Please try again."
      });
    }
  }
})

// function checkPasswordCookie() {
//     var lemonPSWD = getCookie("dv-love-lemon-cookie");
//     if (lemonPSWD == 'true') {
//       $('main#main-content').css('display','block');
//       $('.dv-love-for-lemon-pswd-wrap').fadeOut('slow');
//     } else {
//       $('main#main-content').css('display','none');
//       $('.dv-love-for-lemon-pswd-wrap').show();
//     }
//   }

// checkPasswordCookie();
/* 27-04-23 Start dv-love-for-lemons */

//  CART UPSELL CAROUSEL ITEMS
$('body').on('click','.fallback-preview-lp-pro-grid .quick_add_btn.quick_add',function(e){
	e.preventDefault();
    var ___this = $(this);
    ___this.parents('.ais-hit--details').find('.quick_view_sizes .swatch-element:first').trigger('click');
});
//  CART UPSELL CAROUSEL ITEMS
$('body').on('click','.fallback-preview-lp-pro-grid:not(.love-for-lemon-grid) .quick_close_btn',function(e){
	e.preventDefault();
  var ___this = $(this);
  $(this).parents('.ais-hit--details').removeClass('quick_view_opened');
  $(this).parents('.ais-hit--details').find('.details_left_content_wp').show('fast', function(){
    $(this).parents('.ais-hit--details').find('.quick_view_size_wp').hide('fast');
  });
  setTimeout(function(){opend_pop.focus()},500);
});

$('body').on('click','.fallback-preview-lp-pro-grid .swatch_wrap .swatch-element',function(e){
  e.preventDefault();
  var __this = $(this);
  var handle = $(this).attr('data-handle');
  $(this).parents('.swatch_wrap').find('.swatch-element').removeClass('custom_current_one_color');
  $(this).addClass('custom_current_one_color');
    $.get( '/products/'+ handle +'?view=product-card', function( data ) {
      var new_data = data.split('[prosplit]');
      __this.parents('.fallback-preview-lp-pro-item').find('.product_slider_img').html(new_data[0]);
      __this.parents('.fallback-preview-lp-pro-item').find('.ais-hit--title a').attr('href',new_data[2]).text(new_data[1]);
      __this.parents('.fallback-preview-lp-pro-item').find('.ais-hit--price').html(new_data[3]);
      __this.parents('.fallback-preview-lp-pro-item').find('.quick_view_sizes').html(new_data[4]);

      __this.parents('.fallback-preview-lp-pro-item').find('.quick_view_sizes').find('input:checked').removeAttr('checked');
      
      if ($('.bundle-page-template').length > 0 && __this.parents('.bundle-collection').length > 0){
        __this.parents('.fallback-preview-lp-pro-item').find('.product_slider_img a').attr('href','javascript:void(0)');
        __this.parents('.fallback-preview-lp-pro-item').find('.ais-hit--title a').attr('href','javascript:void(0)');
      }
      // ABTextRun();
      // ABBagdeTextRun();
    }).error(function(event, jqxhr, exception) {
    });
});
var add_mf = $('body').attr('data-money');
$('body').on('click','.fallback-preview-lp-pro-item:not(.bundle-pro-item) .quick_view_sizes .swatch-element',function(e){
  e.preventDefault();
  var $this = $(this);
  var v_id = $(this).attr('data-variant-fbid');
  var p_handle = $(this).attr('data-product');
  var attr = $(this).attr('data-pre-order_date');
  var atcLocation = '';
  if ($(this).parents('.cart-upsell-body').length != 0){
    atcLocation = "Mini-Cart"
  } else if ($(this).parents('.cartItemData').length != 0) {
    atcLocation = 'Cart Page';
  } else if ($(this).parents('.product-upsell-items').length != 0) {
    atcLocation = 'Product Upsell';
  } else {
    atcLocation = 'Page-Template';
  }
  opend_pop = $(this).find('label');
  
  var datap = [];
  var items = {},prop = {};
  
  items.id = v_id;
  items.quantity = 1;
  if (typeof attr !== 'undefined' && attr !== false) {
    if($(this).attr('data-pre-order_date').length > -1 ){
        prop['EXPECTED TO SHIP'] = attr;
        prop['PRE-ORDERED ITEMS'] = '1';
       items.properties = prop;
    }
  }
    
  datap.push(items);
  
  $('.pro_size_error').remove();
  if($(this).attr('data-avaiable') == 'false'){
    $.get('/products/'+p_handle+'?view=back-in-stock&variant='+v_id,function(coll_data){
    $('.fallback-BIS-container').html(coll_data);
    $('.fallback-BIS-container').addClass('bis-popup-opened');
    $('body').addClass('bis-body-popup-opened');
    setTimeout(function(){$('#fallback-BIS-wrap').focus()},500);
  });
  } else {
  // Add to cart.
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      type: 'post',
      data: datap[0],
      success: function(itemData) {
        // Re-enable add to cart button.
        setTimeout(function(){
          $.get("/cart?view=mini&" + Math.random(), function( data ) {
              // $('body .mini-shopping-cart').html(data);
              var new_data = data.split('[cartsplit]');
               $('body .mini-shopping-cart .main-cart-dt-rep').html(new_data[0]);
               $('body .mini-shopping-cart .cart__subtotal').html(new_data[1]);
               
              if ($('#smallcart').find('.empty-page-content1').length == 0){
                $('footer.cart__footer').show();
              } else {
                $('footer.cart__footer').hide();
              }
              cartCollectionSlider();
              // ABTextRun();
              // ABBagdeTextRun();
            
              var GWPEle = new_data[2];
              addFreeGiftProduct('add', GWPEle);
          });
          setTimeout(function(){
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
          },500);        
          $("body").addClass("cartOpen");
          $("#smallcart").addClass("active-mini");
          $.getJSON('/cart.js', function(c){
            $('.mini-cart .cart-icon > span:not(.sr-only)').html(c.item_count);
          });
          setTimeout(function(){$('#mini-shopping-cart').focus()},500);
          $(this).prop('checked', false);
        },500);
        
        var expectedShipDate = itemData.properties != null ? itemData.properties['EXPECTED SHIP DATE'] != null ? itemData.properties['EXPECTED SHIP DATE'] : '' : '';
        var size = itemData.variant_options.length > 1 ? itemData.variant_options[1].trim() : '';
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'addToCart',
          addToCartLocation: atcLocation,
          product: {
            id: itemData.product_id,
            sku: itemData.variant_id,
            style: itemData.sku,
            name: itemData.title,
            price: (parseInt(itemData.final_price)/100).toFixed(2),
            basePrice: (parseInt(itemData.original_price)/100).toFixed(2),
            quantity: itemData.quantity,
            brand: itemData.vendor,			
            color: itemData.variant_options[0].trim(),
            colorFamily: itemData.variant_options[0].trim(),
            size: size,
            expectedShipDate: expectedShipDate
          },
          productRaw: JSON.parse($('#product_json-'+p_handle).html())
        });
        setTimeout(function() {
          updateCartEvent(itemData, 'add', 1)
        }, 1000);
        if ($this.parents('.cart-upsell-body').length == 0){
          cartUpsellitems();
        }
      }, 
      error: function(XMLHttpRequest) {
        $(this).parent().append('<p class="pro_size_error">This size is not available.</p>')
      }
    });
  }
});

$('body').on('click','.fallback-BIS-container .coll-bis-close',function(e){
  e.preventDefault();
  $('.fallback-BIS-container').empty();
  $('.fallback-BIS-container').removeClass('bis-popup-opened');
  $('body').removeClass('bis-body-popup-opened');
  setTimeout(function(){opend_pop.focus()},300);
});

$("body").on("click",".coll-bis-submit",function(){
    var form = $(this).closest('form#bis_form');
    var sid = $(this).attr("data-variant-id");
    var _this = $(this);
    var email = _this.closest('.fallback-BIS-inner-wrap').find('input#email').val();
    var pid = _this.attr('data-product-id');
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    $('#coll-error_message').empty();
    $('.emsg').empty();
    if (email != "" && isValidEmailAddress(email)) {
       $.ajax({
        url: 'https://api.ometria.com/forms/signup/ajax',
        data: form.serialize(),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        type: 'post', 
        success: function(s) {
          if(s.ok) {
              console.log('Ometria response',s)
             _this.closest('.fallback-BIS-inner-wrap').find('#collcompleted_message').addClass('active');
             _this.hide();
             form.find('input#email').attr('aria-invalid','false');
             form.parent().append('<p class="emsg success">You will be notified once the item is back in stock.</p>');
             form.hide();            
             $('.fallback-preview-lp-featured-grid-wrapper').find('.quick_view_sizes [data-variant-fbid="'+sid+'"] input').prop('checked','false');
          } 
        },
        error: function(e) { 
          jQuery('.error').remove();
          if(data.statusText == "BAD REQUEST") {
            form.parent().append('<p class="emsg error">The email already subscribed!</p>');
          }
        }
      })
    }
    else {
      $(this).closest('.fallback-BIS-inner-wrap').find('#coll-error_message').html('Please enter valid email.');
      $(this).closest('.fallback-BIS-inner-wrap').find('input#email').attr('aria-invalid','true').focus();
    }
});

$(document).ready(function() {
// --------- fallback Marque section --------- // 
$('.fallback_marqee_slider').slick({
      speed: 5000,
      autoplay: true,
      autoplaySpeed: 0,
      centerMode: false,
      cssEase: 'linear',
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      infinite: true,
      arrows: false,
      buttons: false
});
 
// --------- fallback featured collection section --------- // 
$('.fallback-preview-lp-grid-slider').slick({
      infinite: true,
      centerMode: false,
      arrows: true,
      dots: false,
      autoplay: false,
      speed: 1000,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
          {
          breakpoint: 1300,
          settings: {
              slidesToShow: 2
          },
          },
          {
              breakpoint: 575,
              settings: {
              slidesToShow: 1                
              }
          }
      ]
  });
  // seasonal edit image slider
  $('.fallback-featured-product-slider').slick({
      dots: true,
      arrow: true,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1
    });
  $('.mobile-image-slider').slick({
      dots: false,
      arrow: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1
  });
// Fallback Preview LP End

  var c = window.location.hash; 
  var header_height = $('.main_header_new').outerHeight(); 
  if($(window).width() < 991){
    if($(c).length > 0 && $('.page_the-seasonal-edit').length > 0){
      const div = document.querySelector(c);  
      const paddingTop = window.getComputedStyle(div, null).getPropertyValue('padding-top');
      var h = header_height + parseInt(paddingTop);
      setTimeout(function(){
        $('html, body').animate({
          scrollTop: $(c).offset().top - h
        }, 1500);
      },2000);
    }
  }
});
  
function setCookie(cname,cvalue,exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

// if (window.location.href.indexOf('utm_source=attentive') > -1){
//   setCookie('GWP-free-utm','hasFree',1);
// }

/*show truyo banner for al page start*/
  function tryou_popup(cntry = 'US'){
    function show_truyo_banner() {
      if ($("#cookieSettingButton").length == 0) {
        //it doesn't exist
      } else {
        clearInterval(interval_main)
        $("#cookieSettingButton").click();
        if(cntry != 'US'){
          setCookie('show_truyo_popup',1,30);
        }
      }
    }
    function change_banner_text() {
      if ($("#pane-78e0e2ff-4b1c-4ca9-bec1-58e69ca1ba47").length == 0) {
        //it doesn't exist
      } else {
        clearInterval(interval_text);
        $("#pane-78e0e2ff-4b1c-4ca9-bec1-58e69ca1ba47").prepend(top_text);
        $("#78e0e2ff-4b1c-4ca9-bec1-58e69ca1ba47").click();
        $("#privacyPolicy").hide();                
      }
    }
    var interval_text = setInterval(change_banner_text, 500);
    var interval_main = setInterval(show_truyo_banner, 500);
    var top_text = '<h2 style="text-align:center;font-size:16px">California Do Not "Sell" Request Center</h2><p>This Website uses cookies to improve performance, provide a world-class shopping experience and, in certain instances display more relevant Dolce Vita ads to you. Some of these cookies, as defined by the CCPA, are considered a "sale" of personal information. If you would like to opt-out of the sale of these cookies and the information associated to them, you may use the toggle switch below next to "Advertising Cookies."</p><h2 style="text-align:center;font-size:16px">Manage Cookie Preferences</h2><div class="d-flex align-items-center"><div style="font-weight:500;font-size:20px">Required Cookies</div><div class="ml-5 " style="color: crimson;font-weight: bold;">Always Active</div></div></div><p>These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in, or filling in forms.</p><p>You can set your browser to block or alert you about these cookies, but some parts of the site will not work.</p>';    
  }

  var show_truyo_popup_cookie = getCookie("show_truyo_popup");
  if(show_truyo_popup_cookie != 1){
     jQuery.get('/browsing_context_suggestions.json', (d) => { 
      if( d.detected_values.country.handle != 'US'){
        setTimeout(function(){
          tryou_popup(d.detected_values.country.handle);
        },3000);
      }else{
        setCookie('show_truyo_popup',0);
         if(window.location.hash == '#show_popup'){
          setTimeout(function(){
            tryou_popup();
          },3000);
        }
      }
     });
  }

  /*show truyo banner for al page end*/

// if ($(window).width() <= 991 ){
//   var h = '-'+$('#shopify-section-top-bar').height()+'px';
//   $('.main_header_new .headerbar .toggleSearchBox').css('top',h);
// }

// Shopping gives Start
$("body").on("click",".radio-btn",function() {
  $("input").removeAttr("checked");
  $(this).attr('checked', true);
});

var c = 0;
function check_widget(){
  if($('.main-element.sg-campaign-active').length > 0){
      $('#sg-custom-widgets-container').show();
      $('#shopify-section-customer-direct-donation').show();
  }else{
    if(c < 50){
      setTimeout(function(){
        c++;
        check_widget();
      },1000);
    }
  }
}
check_widget();

// Shopping gives text change
function changeShoppingText() {
  if ($(".sg-addon-description").length == 0 && $(".sg-addon-precauseText").length == 0 ) {
  } else {
    clearInterval(spanText);
    $(".sg-addon-description").replaceWith('We encourage you to join us in supporting the following organizations we stand behind.');
    $(".sg-addon-precauseText").remove();
  }
}
var spanText = setInterval(changeShoppingText, 500);

jQuery(window).load(function () {
  setTimeout(changeShoppingText, 8000);
})

// Shopping gives text change

$('body').on('click','span.select-text.sg-open-charity-select',function(){
  setInterval(changeShoppingText, 500);
})

$("body").on("click","#sg-custom-widgets-container input[type='radio']",function() {
  var radioValue = $("input[type='radio']").val();
  var radioSelected = $(this).val();
  var num = radioSelected.toString();
  console.log(num)
});

$("body").on("click",".custom_add_to_cart, .radio-btn",function() {
  var radioValue = $("input[type='radio']").val();
  var radioSelected = $(this).val();
  var variant_id1 = $(".variant_option option:selected").val();
  var variant_id2 = radioSelected.toString();
  var variant_id3 = $(".default_variant_id").val();
  var product_id = $(".product_id").data("value");

  if (typeof variant_id1 === "undefined") {
    if (typeof variant_id2 === "undefined") {
      var variant_id = variant_id3;
    } else {
      var variant_id = variant_id2;
    }
  } else {
    var variant_id = variant_id1;
  }

  setTimeout(function() {
    if (variant_id == null) {

    } else {
      var data = {
        "quantity": 1,
        "id": variant_id,
        "product_id": product_id,
        "properties" : {
           "_donation" : "Yes"
        }
      }

      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        async: false,
        data: data,
        dataType: 'json',
        success: function() {
          window.location.reload();
        }
      });
    }
  }, 300);
});

var total_length = $(".variant_option option").length;

if (total_length < 2) {
  $(".variant_option_span").show();
  $(".variant_option").hide();
} else {
  $(".variant_option_span").hide();
  $(".variant_option").show();
}
// Shopping gives End

// Bundle page 09-03-23 Start
$('.fallback-bundle-grid-slider').slick({
    infinite: false,
    centerMode: false,
    arrows: true,
    dots: false,
    autoplay: false,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
        breakpoint: 1024,
        settings: {
            slidesToShow: 2
        },
        },
        {
            breakpoint: 767,
            settings: {
            slidesToShow: 1               
            }
        }
    ]
});

function scrollHTML(_this){
  $('html, body').animate({
        scrollTop: _this.offset().top
  }, 1000);
}

$('body').on('change','.bundle-pro-item input[type="radio"]',function(){
  var price = 0;
  if ($(this).prop("checked")){
    $(this).parents('.bundle-collection-wrapper').find('input[type="radio"]').prop('checked', false);
    $(this).prop("checked",'true');
  }
  $('.bundle-collection-wrapper').each(function(index, val){
    if (!isNaN($(val).find('.swatch-element.size input[type=radio]:checked').attr('data-variant-price'))){
      // if ($(val).attr('data-bundle') == '2'){
      //   price = price + parseFloat(parseFloat($(val).find('.swatch-element.size input[type=radio]:checked').attr('data-variant-price') * ((75) / 100 )).toFixed(2));
      // } else {
        // price = price + parseFloat($(val).find('.swatch-element.size input[type=radio]:checked').attr('data-variant-price'));
      // }
      price = price + parseFloat(parseFloat($(val).find('.swatch-element.size input[type=radio]:checked').attr('data-variant-price') * ((75) / 100 )).toFixed(2));
    }
  });
  
  // $('.bundleAddtoCart .bundle-atc-price').html(Shopify.formatMoney(price*100, add_mf))
  $('.bundleAddtoCart .bundle-atc-price').html('$'+ parseFloat(price).toFixed(2));
  var afterpay_price = price / 4;
  $('.custom-afterpay .afterpay-main-text').find('.afterpay-custom-price').html('$'+parseFloat(afterpay_price).toFixed(2));

  // $('.bundleAddtoCart .bundle-atc-price').html(Shopify.formatMoney(price*100, add_mf))
  $('.bundleAddtoCart .bundle-atc-price').html('$'+ parseFloat(price).toFixed(2));
  var afterpay_price = price / 4;
  $('.custom-afterpay .afterpay-main-text').find('.afterpay-custom-price').html('$'+parseFloat(afterpay_price).toFixed(2));

  // SCROLL HTML
  if ($(this).parents('#bundle-collection-1').length > 0 && $('#bundle-collection-1').find('.swatch-element.size input[type=radio]:checked').length == 1 && $('#bundle-collection-2').find('.swatch-element.size input[type=radio]:checked').length == 0){
    scrollHTML($("#bundle-collection-2"));
  } else if ($(this).parents('#bundle-collection-2').length > 0 && $('#bundle-collection-2').find('.swatch-element.size input[type=radio]:checked').length == 1 && $('#bundle-collection-1').find('.swatch-element.size input[type=radio]:checked').length == 0){
    scrollHTML($("#bundle-collection-1"));
  } else if ($('#bundle-collection-2').find('.swatch-element.size input[type=radio]:checked').length == 1 && $('#bundle-collection-1').find('.swatch-element.size input[type=radio]:checked').length == 1 ) {
    scrollHTML($('#bundle-checkout-wrap'));
  }
  // SCROLL HTML
});

$('body').on('click','.bundleAddtoCart',function(e){
  e.preventDefault();
  var $this = $(this).parents('.bundle-checkout-wrapper').prev('.bundle-content-wrapper'), btn_this = $(this);
  $('.Bundle_error').remove();
  $this.find('.bundle_add_error').remove();
  opend_pop = $(this);
  if($('.bundle-collection-wrapper').find('.swatch-element.size input[type="radio"]:checked').length < 2 ){
    $(this).parent().after('<p class="Bundle_error">Please select two products from above collections.</p>')
  }else{
    $.getJSON('/cart.json',function(cart){
      var all_current_items = [],all_current_items_pid = [];
      $(cart.items).each(function(ii,cc){
        if(typeof cc.properties['bundle_id'] !== 'undefined'){
          all_current_items.push(cc.id);
          all_current_items_pid.push(cc.product_id);
        }
      });
      var JSONObj = [],colorobj = [];
      var total_pro = $this.find('.bundle-collection-wrapper').length;
      var selected_pro = $this.find('.bundle-collection-wrapper').find('.swatch-element.size input[type="radio"]:checked').length;
      var uniq_id = Math.round(Date.now() / 1000);
      $this.find('.bundle-collection-wrapper').each(function(index, val){
        var bv_id = Number($(val).find('.swatch-element.size input[type=radio]:checked').parent('.swatch-element').attr('data-variant-fbid'));
        var pre_order_date = $(val).find('.swatch-element.size input[type=radio]:checked').parent('.swatch-element').attr('data-pre-order_date');
        var colid = Number($(val).find('.swatch-element.size input[type=radio]:checked').attr('data-product'));
        if((all_current_items.indexOf(bv_id) > -1)|| (all_current_items_pid.indexOf(colid) > -1)){
          $('.Bundle_error').remove();
          btn_this.parent().after('<p class="Bundle_error">Selected color and size is already in cart. Please select a different color and size.</p>');
          return false;
        }

        
      
        colorobj.push(colid);
        var already=false;
        // if ($(val).attr('data-bundle') == '2') {
        //   JSONObj.push({
        //     "quantity": 1,
        //     "id": bv_id,
        //     "properties":{
        //       "bundle_uniqid": 'custom_bundle',
        //       "bundle_discount": 'Yes',
        //       "bundle_id": uniq_id
        //     }
        //   });
        // } else {
          // JSONObj.push({
          //   "quantity": 1,
          //   "id": bv_id,
          //   "properties":{
          //     "bundle_uniqid": 'custom_bundle',
          //     "bundle_discount": 'Yes',
          //     "bundle_id": uniq_id
          //   }
          // });
        // }

        if (typeof pre_order_date !== 'undefined' && pre_order_date !== false) {
          if(pre_order_date.length > -1 ){
            JSONObj.push({
              "quantity": 1,
              "id": bv_id,
              "properties":{
                "bundle_uniqid": 'custom_bundle',
                "bundle_discount": 'Yes',
                "bundle_id": uniq_id,
                "PRE-ORDERED ITEMS": 1,
                "EXPECTED TO SHIP": pre_order_date
              }
            });
          }
        } else {
          JSONObj.push({
            "quantity": 1,
            "id": bv_id,
            "properties":{
              "bundle_uniqid": 'custom_bundle',
              "bundle_discount": 'Yes',
              "bundle_id": uniq_id
            }
          });
        }
      });
      
      if((JSONObj[0].id != JSONObj[1].id)&&(colorobj[0] == colorobj[1])){
        $('.Bundle_error').remove();
        btn_this.parent().after('<p class="Bundle_error">Both selected colors are same. Please select different colors to achieve bundle.</p>');
        return false;
      }else if(JSONObj.length == 2){
        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            items : JSONObj
          },
          async: false,  
          dataType: 'json',
          error: function(jqXHR, textStatus, errorThrown){
            if(jqXHR) {
              var response = jQuery.parseJSON(jqXHR.responseText);
              btn_this.parent().after('<p class="Bundle_error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
            }
            btn_this.parent().after('<p class="Bundle_error">Something went wrong. Please try again later.</p>')
          }
      }).done(function( data ) {
        $.get( "/cart?view=mini", function( data ) {
          // $('.mini-shopping-cart').html(data);
          var new_data = data.split('[cartsplit]');
           $('body .mini-shopping-cart .main-cart-dt-rep').html(new_data[0]);
           $('body .mini-shopping-cart .cart__subtotal').html(new_data[1]);
           
          if ($('#smallcart').find('.empty-page-content1').length == 0){
            $('footer.cart__footer').show();
          } else {
            $('footer.cart__footer').hide();
          }
          cartCollectionSlider();
          // ABTextRun();
          // ABBagdeTextRun();
          
          var GWPEle = new_data[2];
          addFreeGiftProduct('add', GWPEle);
          
          $("body").addClass("cartOpen");
          $("#smallcart").addClass("active-mini");
          $.getJSON("/cart.js", function(cart) {
            $('.mini-cart .cart-icon > span:not(.sr-only)').html(cart.item_count);
          });
          setTimeout(function(){
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
          },500);
        });
        var dataLayerUpsellProducts = [], createupsellDataLayerProduct = {};
            for ( var i = 0; i < data.items.length; i++){
              var size = data.items[i].variant_options.length > 1 ? data.items[i].variant_options[1].trim() : '';
              var expectedShipDate = data.items[i].properties != null ? data.items[i].properties['EXPECTED SHIP DATE'] != null ? data.items[i].properties['EXPECTED SHIP DATE'] : '' : '';
              var objUpsell = {
                  id: data.items[i].product_id,
                  sku: data.items[i].variant_id,
                  style: data.items[i].sku,
                  name: data.items[i].title,
                  price: (parseInt(data.items[i].final_price)/100).toFixed(2),
                  basePrice: (parseInt(data.items[i].original_price)/100).toFixed(2),
                  quantity: data.items[i].quantity,
                  brand: data.items[i].vendor,			
                  color: data.items[i].variant_options[0].trim(),
                  colorFamily: data.items[i].variant_options[0].trim(),
                  size: size,
                  expectedShipDate: expectedShipDate
              }
              dataLayerUpsellProducts.push(objUpsell)
            }
            if (dataLayerUpsellProducts.length != 0 || dataLayerUpsellProducts != undefined){
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "addToCart",
                addToCartLocation: 'Bundle Page',
                addToCart: {
                    name: $('.bundle-content-wrapper').data('page-handle') + ' page',
                    products: dataLayerUpsellProducts,
                }
              })
            }
      });
      cartUpsellitems();
      $('.Bundle_error').remove();
    }
  });
  }  
});

if ($('.bundle-page-template').length > 0 && $('.bundle-collection-wrapper').length > 0){
  $('.bundle-collection-wrapper .grid-wrapper').find('.product_img_wp a').attr('href','javascript:void(0)');
}
// Bundle page 09-03-23 End

/* Accessibility changes 22-03-23 */
$(document).keydown(function(e) {
 var key = e.which;
  if(key==37 || key == 38 || key == 39 || key == 40){
      e.preventDefault();
      return false;
  }
  if ($(window).width() < 767){
    if (key == 32 && $(e.target).hasClass('mobileNav') && e.target != document.body){
      e.preventDefault();
      return false;
    }
  }
  return true;
});
$(document).ready(function(){
  // #20: This text input with autocomplete functionality is missing critical ARIA attributes.
  if ($('input#SearchInput').length > 0) {
    var attr = $('input#SearchInput').attr('role');
    var attr_aria_autocomplete = $('input#SearchInput').attr('aria-autocomplete');
    if (typeof attr !== 'undefined' && attr !== false) {
      $('input#SearchInput').removeAttr('role');
    }
    // #11:
    if (typeof attr_aria_autocomplete !== 'undefined' && attr_aria_autocomplete !== false) {
      $('input#SearchInput').attr('aria-autocomplete','list');
    }
  }
  // #80: This element has an unnecessary ARIA attribute.
  function removeUnwantedAttr(){
    if ($('.slick-initialized').length > 0 && typeof $('.slick-list').attr('aria-live') !== undefined) {
      var attr = $('.slick-list').attr('aria-live');
      if (typeof attr !== 'undefined' && attr !== false) {
        $('.slick-list').removeAttr('aria-live');
      } 
    } else {
      setTimeout(removeUnwantedAttr,500);
    }
  }
  removeUnwantedAttr();
  // function addLabels(){
  //   if ($('.swym-add-to-wishlist_custom').length > 0){
  //     $('.cart__row').each(function(i,index){
  //         if($(index).find('.swym-add-to-wishlist_custom').hasClass('swym-added')){
  //             $(index).find('.swym-add-to-wishlist_custom').attr('aria-current','true');  
  //         } else {
  //             $(index).find('.swym-add-to-wishlist_custom').attr('aria-current','false');
  //         }
  //     })
  //     setTimeout(addLabels,2500);
  //   }  
  // }
  // addLabels();
  // $('body').on('click','.mini-wishlist_wrap > a',function(){
  //   addLabels();
  // });
  // This Slick Slider carousel is incorrectly marked up as a listbox.
  function removeListbox(){
    if ($('.slick-slider').length && $('.slick-track').attr('role') != undefined){
      $('.slick-track').removeAttr('role');
    } else {
      setTimeout(removeListbox, 20);
    }
  }
  removeListbox();
  $('.slick-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
    removeListbox();
  });
  // This Slick Slider carousel is incorrectly marked up as a listbox.
  /* flaoting a label */
  $("body").on('blur','.floating-label input,.floating-label textarea',function(e){
    if($(this).val() == '') {
      $(this).parent('span').removeClass('no-focus');
    }else{
      $(this).parent('span').addClass('no-focus');
    }
  });
  $('body').on("keydown",".swatch-element",function(e){
    if(e.keyCode === 13) {
        $(this).find('input').trigger('click');
    }
  });
  $('body').on("keydown",".ais-facets .ais-facet--item>div input[type=checkbox]",function(e){
      if(e.keyCode === 13) {
        $(this).trigger('click');
      }  
  });
  function stopfocusOnBody(evt,firstElement,lastElement){
    if (evt.key === 'Tab' || evt.keyCode === 9) {
      // Tab key pressed
      if (evt.shiftKey) {
        // Shift + Tab
        if (document.activeElement === firstElement[0]) {
          evt.preventDefault();
          // Set focus on the last link
          lastElement.focus();
        }
      } else {
        // Tab
        if (document.activeElement === lastElement[0]) {
          evt.preventDefault();
          // Set focus on the first link
          firstElement.focus();
        }
      }
    }
  }
  $('#hamburger-mobile-nav').on('keydown', function(evt) {
    var firstLink = $(this).find('.close-menu');
    var lastLink = $(this).find('.title.icon_title:last a');
    stopfocusOnBody(evt,firstLink,lastLink)
  });
  $('body').on('keydown','.backInStock_modal', function(evt) {
    var firstLink = $('.backInStock_modal-close');
    var lastLink = $('.backInStock_modal-submit');
    stopfocusOnBody(evt,firstLink,lastLink)
  });
  $('body').on('keydown','#fallback-BIS-wrap', function(evt) {
    var firstLink = $('.coll-bis-close');
    var lastLink = $('.coll-bis-submit');
    stopfocusOnBody(evt,firstLink,lastLink)
  });
  $('body').on('keydown','#phtoswipe-gallery', function(evt) {
    var firstLink = $('#phtoswipe-gallery');
    var lastLink = $('.pswp__button--close');
    stopfocusOnBody(evt,firstLink,lastLink)
  });
  $('.table_layout').on('keydown', function(evt) {
    var firstLink = $('.closeIMG');
    var lastLink = $('.size_table');
    stopfocusOnBody(evt,firstLink,lastLink)
  });
  function fetchlastbtn(evt){
    var evt = evt;
    if ($('.dynamic-checkout__content ul li:last [role="button"]').length != 0){
      var firstLink = $('.cart-close');
      var lastLink = $('.dynamic-checkout__content ul li:last [role="button"]');
      stopfocusOnBody(evt,firstLink,lastLink)
    } else {
      setTimeout(function(){
        fetchlastbtn(evt);
      },500);
    }
  }
  $('body').on('keydown','#mini-shopping-cart', function(evt) {
    fetchlastbtn(evt);
  });
  
  // #1: All pages with more than just a few links should have a "Skip to Main Content" link.
  $('a.skip-link[href^="#"]').on('click',function (e) {
    e.preventDefault();
    var target = this.hash;
    var $target = $(target);
    $('html, body').stop().animate({
        'scrollTop': $target.offset().top
    }, 900, 'swing', function () {
        window.location.hash = target;
    });
  });
  var navbar = document.querySelector('#AccessibleNav'), menuVisible = false, toggleButton = document.querySelector('.toggle-button');
  function showMenu(_this) {
     _this.next('.toggle-button').attr('aria-expanded', 'true');
     _this.parents('li.hasDropDown').addClass("add_hover");
     menuVisible = true;
  }
  
  function hideMenu() {
    $('#AccessibleNav li.hasDropDown').removeClass('add_hover');
    $('#AccessibleNav li.hasDropDown > span .toggle-button').attr('aria-expanded', 'false');
    menuVisible = false;
  }
  
  function toggleMenu(_this) {
    if (_this.parents('li').hasClass('hasDropDown')){
      if(menuVisible) {
        hideMenu();
      } else {
        showMenu(_this);
      }
    }
  }
  
  // Close the menu when the user activates something outside the navbar.
  document.body.addEventListener('click', handleBodyClick);
  document.body.addEventListener('keyup', handleBodyClick);
  function handleBodyClick(e) {
    if(!navbar.contains(e.target)) {
      hideMenu();
    }
  }
  
  jQuery('body').on('click','.toggle-button', function(e){
    toggleMenu($(this).prev('a.site-nav__link'));
  });
    
  $('body').on("mouseover","#AccessibleNav li.hasDropDown",function(e){
    toggleMenu($(this).find('a.site-nav__link')); 
  });
  
  $('body').on("mouseout","#AccessibleNav li.hasDropDown",function(e){
    hideMenu();
  });

  $('input[name="q"]').on('input',function(){
    if ($.trim($(this).val()) != '') {
      $(this).attr('aria-expanded','true');
    } else if ($.trim($(this).val()) == ''){
      $(this).attr('aria-expanded','false');
    }
  });
  
  $('input[name="q"]').on('blur focusout',function(){
    $(this).attr('aria-expanded','false');
  });

  if ($(window).width() > 768){
    $('body').on("keyup","#AccessibleNav > li > span, #AccessibleNav > li:not(.hasDropDown)",function(e){
        $(this).next('.dropdownMenu').find('li a').removeClass('insideUl');
        if((e.keyCode === 9 && !e.shiftKey) || e.keyCode === 9) {
          if (!$(e.target).hasClass('toggle-button')){
            hideMenu();
            $('a.menu_only_title').attr("tabindex","-1");
            if(e.keyCode === 27) {
              $(this).focus();
            }
          }
        }
        if(e.keyCode === 37 || e.keyCode === 38 || e.keyCode === 39 || e.keyCode === 40 ) {
          console.log(98098080, $(this).parent('.hasDropDown').find('.dropdownmenu').length);
          if ($(this).parent('.hasDropDown').find('.dropdownmenu').length > 0 ){
           // dropdown
            if($(this).parent('.hasDropDown').find('.dropdownmenu').find('li.col_menu_only').length > 0 ){
              // first-type
                if($(this).parent('.hasDropDown').find('.dropdownmenu').find('li.col_menu_only:first > a').length > 0){
                  if (!$(this).parent('.hasDropDown').find('.dropdownmenu').find('li.col_menu_only:first a.menu_only_title').hasClass('insideUl')){
                    $('a.menu_only_title').attr("tabindex","-1");
                    $(this).parent('.hasDropDown').find('.dropdownmenu').find('li.col_menu_only a.menu_only_title').attr("tabindex","0");
                    $(this).parent('.hasDropDown').find('.dropdownmenu').find('li.col_menu_only:first a.menu_only_title').focus().addClass('insideUl');
                  }
                }
              // second-type
                else {
                  if(!$(this).parent('.hasDropDown').find('.dropdownmenu').find('li.col_menu_only:first ul > li:first > a').hasClass('insideUl')){
                    $('a.menu_only_title').attr("tabindex","-1");
                    $(this).parent('.hasDropDown').find('.dropdownmenu').find('li.col_menu_only ul > li:first > a.menu_only_title').attr("tabindex","0");
                    $(this).parent('.hasDropDown').find('.dropdownmenu').find('li.col_menu_only:first ul > li:first > a').focus().addClass('insideUl');
                  }else{
                    $(this).parent('.hasDropDown').find('.dropdownmenu').find('li.col_menu_only:first ul > li > a.insideUl').parent('li').next('li > a').focus().addClass('insideUl');
                  }
                }
              }
             // third-type
              else {
                if(!$(this).parent('.hasDropDown').find('.dropdownmenu').find('li.col_menu_only:first ul > li:first > a').hasClass('insideUl')){
                  $(this).parent('.hasDropDown').find('.dropdownmenu').find('li:not(.backTitle):first > a').focus().addClass('insideUl');
              }
            }
          }
        } else if(e.keyCode === 13 ) {
          if($(this).parent('.hasDropDown').find('.dropdownmenu').find('li.col_menu_only ul li > a')){
           $(this).parent('.hasDropDown').find('.dropdownmenu').find('li.col_menu_only ul li:first > a').trigger('click'); 
          }  
        }
        if (e.keyCode === 27){
          hideMenu();
        }
    });
    
    // Dropdown navigation
    $('body').on("keyup","li.col_image_only img, li.col_image_only > a, .closecart", function(e){
      if(e.keyCode === 37 || e.keyCode === 38) {
        if ($(this).parent().prev('li').hasClass('col_image_only')){
          $(this).parent().prev('li').find('a').focus().addClass('insideUl');
        } else {
          if ($(this).parent().prev('li').find('a.menu_only_title').length > 0){
            $(this).parent().prev('li').find('a.menu_only_title').focus().addClass('insideUl');
          }
        }
      } 
      if (e.keyCode === 39 || e.keyCode === 40){
        if ($(this).parent().next('li').length == 0){
          if ($(this).parent().prev('li').find('a.menu_only_title').length > 0){
            $(this).parent().prev('li').find('a.menu_only_title').focus().addClass('insideUl');
          }
        } else {
          if ($(this).parent().next('li').hasClass('col_image_only')){
            $(this).parent().next('li').find('a').focus().addClass('insideUl');
          } else {
            if ($(this).parent().next('li').find('a.menu_only_title').length > 0){
              $(this).parent().next('li').find('a.menu_only_title').focus().addClass('insideUl');
            }
          }
        }
      }
      if(e.keyCode === 13 ) {
         $(this).trigger('click'); 
      }  
    });
    
    $('body').on("keyup",".dropdownmenu li > a",function(e){
        // LEFT
        if(e.keyCode === 37 ) {
          if($(this).parents('.col_menu_only').prev('li.col_menu_only').length > 0){
            if ($(this).parents('.col_menu_only').prev('li.col_menu_only').find('a').length > 0 ){
                  $(this).parents('.col_menu_only').find('a.menu_only_title').removeClass('insideUl');
                  $(this).parents('.col_menu_only').find('a').removeClass('insideUl');
                  $(this).parents('.col_menu_only').prev('li.col_menu_only').find('a.menu_only_title').focus().addClass('insideUl');
            }else{
              $(this).parents('.col_menu_only').find('a').removeClass('insideUl');
              $(this).parents('.col_menu_only').prev('li.col_menu_only').find('a').focus().addClass('insideUl');
            }
          }
        }
        // UP
        if(e.keyCode === 38 ) {
          if ($(this).hasClass('insideUl') && !$(this).parent('li').is(':first-child')){
            $(this).parent('li').prev('li').find('a').focus().addClass('insideUl');
            $(this).removeClass('insideUl');
          }else{
            if($(this).parents('.col_menu_only').prev('li.col_menu_only').length > 0){
              if ($(this).parents('.col_menu_only').prev('li.col_menu_only').find('a').length > 0 ){
                $(this).parents('.col_menu_only').find('a.menu_only_title').removeClass('insideUl');
                $(this).parents('.col_menu_only').find('a').removeClass('insideUl');
                $(this).parents('.col_menu_only').prev('li.col_menu_only').find('a.menu_only_title').focus().addClass('insideUl');
              }else{
                $(this).parents('.col_menu_only').find('a').removeClass('insideUl');
                $(this).parents('.col_menu_only').prev('li.col_menu_only').find('a').focus().addClass('insideUl');
              }
            }
          }
        }
        // RIGHT
        if(e.keyCode === 39 ) {
          if($(this).parents('.col_menu_only').next('li.col_menu_only').length > 0){
            if ($(this).parents('.col_menu_only').next('li.col_menu_only').find('a').length > 0 ){
                  $(this).parents('.col_menu_only').find('a.menu_only_title').removeClass('insideUl');
                  $(this).parents('.col_menu_only').find('a').removeClass('insideUl');
                  $(this).parents('.col_menu_only').next('li.col_menu_only').find('a.menu_only_title').focus().addClass('insideUl');
            }else{
              $(this).parents('.col_menu_only').find('a').removeClass('insideUl');
              $(this).parents('.col_menu_only').next('li.col_menu_only').find('a').focus().addClass('insideUl');
            }
          }else{
            $(this).parents('.col_menu_only').next('li.col_image_only').find('img').attr('tabindex','-1').focus();
          }
        }
        // DOWN
        if(e.keyCode === 40 ) {
            if ($(this).hasClass('insideUl') && !$(this).parent('li').is(':last-child')){
              $(this).parent('li').next('li').find('a').focus().addClass('insideUl');
              $(this).removeClass('insideUl');
            }else{
              if($(this).parents('.col_menu_only').next('li.col_menu_only').length > 0){
                if ($(this).parents('.col_menu_only').next('li.col_menu_only').find('a').length > 0 ){
                  $(this).parents('.col_menu_only').find('a.menu_only_title').removeClass('insideUl');
                  $(this).parents('.col_menu_only').find('a').removeClass('insideUl');
                  $(this).parents('.col_menu_only').next('li.col_menu_only').find('a.menu_only_title').focus().addClass('insideUl');
                }else{
                  $(this).parents('.col_menu_only').find('a').removeClass('insideUl');
                  $(this).parents('.col_menu_only').next('li').find('a').focus().addClass('insideUl');
                }
              } else if ($(this).parents('li').next('li.col_image_only').length > 0){
                  $(this).parents('li').find('a').removeClass('insideUl');
                  $(this).parents('li').next('li.col_image_only').find('a').focus().addClass('insideUl');
              }
            }
          }
        if((e.shiftKey && e.keyCode === 9)){
          $('.dropdownmenu li a').attr("tabindex","-1"); 
          $(this).closest('li.hasDropDown').prev().find('a').focus();
        }
        if (e.keyCode === 27){
          hideMenu();
        }
    });
  }
  /** Menu visibility end */

  $('body').on("keydown",".new_custom_swatch_size .swatch-element",function(e){
      var thisIndex = parseInt($(this).data('idx')), total_length = $(this).parents('[role="radiogroup"]').find('.swatch-element').length;
      if (e.keyCode === 37 || e.keyCode === 38) { // left & up
        var prev = thisIndex-1;
        if ($(this).parents('.new_custom_swatch_size')){
          if ($(this).parents('.swatch').find('.swatch-element[data-idx="'+ prev +'"]').length > 0){
            $(this).parents('.swatch').find('.swatch-element[data-idx="'+ prev +'"] label').focus();
          } else {
            $(this).parents('.swatch').find('.swatch-element[data-idx="'+ total_length +'"] label').focus();
          }
        }
      } else if (e.keyCode === 39 || e.keyCode === 40) { // right & down
        var next = thisIndex+1;
        if ($(this).parents('.new_custom_swatch_size')){
          if ($(this).parents('.swatch').find('.swatch-element[data-idx="'+ next +'"]').length > 0){
            $(this).parents('.swatch').find('.swatch-element[data-idx="'+ next +'"] label').focus();
          } else {
            $(this).parents('.swatch').find('.swatch-element[data-idx="1"] label').focus();
          }
        }
      }
      if(e.keyCode === 13 || e.keyCode === 32) {
        if ($(this).parents('.new_custom_swatch_size')){
          $(this).parents('.swatch').find('.swatch-element').attr({tabindex: '-1', 'aria-checked':'false'});
          $(this).attr({tabindex: '0', 'aria-checked':'true'}).find('input[type="radio"]').trigger('click');
        }
      }  
  });

  $('body').on("keydown",'.ais-hit--details .swatch_wrap .swatch-element > a',function(e){
    var thisIndex = parseInt($(this).data('idx')), total_length = $(this).parents('[role="radiogroup"]').find('.swatch-element.custom').length;
      if (e.keyCode === 37 || e.keyCode === 38) { // left & up
        var prev = thisIndex-1;
        if ($(this).parents('.swatch_wrap')){
          if ($(this).parents('.swatch_wrap').find('.swatch-element a[data-idx="'+ prev +'"]').length > 0){
            $(this).parents('.swatch_wrap').find('.swatch-element a[data-idx="'+ prev +'"]').focus();
          } else {
            $(this).parents('.swatch_wrap').find('.swatch-element a[data-idx="'+ total_length +'"]').focus();
          }
        }
      } else if (e.keyCode === 39 || e.keyCode === 40) { // right & down
        var next = thisIndex+1;
        if ($(this).parents('.swatch_wrap')){
          if ($(this).parents('.swatch_wrap').find('.swatch-element a[data-idx="'+ next +'"]').length > 0){
            $(this).parents('.swatch_wrap').find('.swatch-element a[data-idx="'+ next +'"]').focus();
          } else {
            $(this).parents('.swatch_wrap').find('.swatch-element a[data-idx="1"]').focus();
          }
        }
      }
      if(e.keyCode === 13 || e.keyCode === 32) {
        if ($(this).parents('.swatch_wrap')){
          $(this).parents('.swatch_wrap').find('.swatch-element a').attr({tabindex: '-1', 'aria-checked':'false'});
          $(this).attr({tabindex: '0', 'aria-checked':'true'}).trigger('click');
        }
      } 
  });
  // Keyboard accessibility end 12-06-23

  //  Allyant Walk Through 24-08-23 Start
  // Define the event
  function addAriaLabel(){
    let event = 'sw:addedtowishlist', event_1 = 'sw:removedfromwishlist';;
    if (typeof _swat !== 'undefined' && typeof window.triggerSwymVariantEvent !== 'undefined'){
      // Define the event listener function
      let listener = function(e) {
        if($('.swym-add-to-wishlist_custom')) {$('.swym-add-to-wishlist_custom').attr('aria-checked','true')}
        setTimeout(function(){
          $('.swym-add-to-wishlist_custom').focus();
        },4000);
      }, 
      listener_1 = function(e) {
        if($('.swym-add-to-wishlist_custom')) {$('.swym-add-to-wishlist_custom').attr('aria-checked','false')}
        setTimeout(function(){
          $('.swym-add-to-wishlist_custom').focus();
        },3000)
      };
      // Add listener for the 'addedtowishlist' event to the Swym Event Layer
      _swat.evtLayer.addEventListener(event, listener);
      _swat.evtLayer.addEventListener(event_1, listener_1);

    } else {
      setTimeout(addAriaLabel,1000);
    }
  }
  addAriaLabel();
  //  Allyant Walk Through 24-08-23 End
});
/* Accessibility changes 22-03-23 */